//import { API_URL, API_V2_URL, API_QMS_URL, BUCKET_NAME, API_FR_URL } from "@env"

export class Serviceurls {

    // static DOMAIN = "https://dev.api.emedhub.in/v2/";
    // static BASE_DOMAIN = "https://dev.api.emedhub.in/";
    static WEB_SOCKET_DOMAIN = "wss://api.emedhub.in/ws/";


    static UAT_DOMAIN = "https://uat.v3.api.emedhub.in/v2/"
    static UAT_BASE_DOMAIN = "https://uat.v3.api.emedhub.in/"

    // beta or line url ----
    // api.emedhub.in
    // static UAT_DOMAIN = "https://api.emedhub.in/v2/"
    // static UAT_BASE_DOMAIN = "https://api.emedhub.in/"

    static DOMAIN = this.UAT_DOMAIN;
    static BASE_DOMAIN = this.UAT_BASE_DOMAIN;

    // static DOMAIN = API_V2_URL;
    // static BASE_DOMAIN = API_URL;
    // static QMA_DOMAIN = API_QMS_URL;
    // s3 Bucket name in Document Page
    //static s3BUCKET_NAME = BUCKET_NAME

    // user role
    static REG_EX_MOBILENO = /[^.[0-9]]*/
    static ROLE_FO = "FO";
    static ROLE_DOCTOR = "doctor";
    static ROLE_OPT = "OPHTHALMOLOGY";
    static ROLE_OPTOMETRY = "OPTOMETRY";
    static ROLE_COUNSELLOR = "COUNSELLOR"

    static LANGUAGES = this.DOMAIN + "languages/"
    static GET_STATE = this.BASE_DOMAIN + "pharmacy/states/";
    static API_SIGN_IN = "auth/login/";
    static API_LOG_OUT = "auth/logout/";
    static HOME_APPOINTMENTS = "doctor/appointments/list/";
    static REG_EX_MOBILENO = /[^.[0-9]]*/

    /**start ---Pharmacy Management API *
    //  * Module List*/
    static GET_MODULES_LIST = "auth/user/linked/modules/"
    /**Reports - Sales Report */
    static GET_SALES_OVERVIEW = "administrator/pharmacy/reports/sales_overview/";
    static GET_SALES_DETAILED = "administrator/pharmacy/reports/sales_detailed/";
    static GET_SALES_GST = "administrator/pharmacy/reports/sales_gst/";
    static GET_SALES_GST_SPLITUP = "administrator/pharmacy/reports/sales_gst_splitup/";
    static GET_SALES_RETURN = "administrator/pharmacy/reports/sales_return/";
    static GET_SALES_MONTHLY = "administrator/pharmacy/reports/sales_monthly/";
    static GET_SALES_DAYEND = "administrator/pharmacy/reports/sales_dayend/";
    static GET_SALES_CONSOLIDATE = "administrator/pharmacy/reports/sales_consolidated/";
    static GET_DICOUNT_REPORT_PHARMACY = 'pharmacy/reports/sales/discount/new/';
    /**Reports - Purchase Report */
    static GET_PURCHASE_OVERVIEW = "administrator/pharmacy/reports/purchase_overview/"
    static GET_PURCHASE_DETAILS = "administrator/pharmacy/reports/purchase_detailed/"
    static GET_PURCHASE_RETURN = "administrator/pharmacy/reports/purchase_return/"
    static GET_PURCHASE_GST = "administrator/pharmacy/reports/purchase_gst/"
    static GET_PURCHASE_MONTHLY = "administrator/pharmacy/reports/purchase_monthly/"
    /**Reports - Purchase Report */
    /** Stock Adjustment Edit Form */
    static STOCK_ADJUSTMENT_EDIT_FROM = "administrator/pharmacy/inventory/stock_adjustment";
    /** Stock Adjustment Edit Form*/
    /**Inventory - Stock Adjustment*/
    static GET_STOCK_ADJUST_LIST = "administrator/pharmacy/inventory/stock_adjustment"
    static GET_DRUG_LIST = "administrator/dashboard/dosage_types/"
    /**Inventory - Stock Adjustment - History*/
    static GET_STOCK_ADJUST_HISTORY_LIST = "administrator/pharmacy/inventory/stock_adjustment/history/"
    static INVENTORY_STOCK_LIST_GET = "lab/product/stock/list/"
    static INVENTORY_STOCK_LIST_PUT = "lab/product/correction/"
    static INVENTORY_STOCK_LIST_DETAILS_GET = "lab/product/stock/detail/"
    static INVENTORY_ACTIVE_INVENTORY_GET = "lab/drug/list/"
    static INVENTORY_ACTIVE_INVENTORY_POST = "lab/drug/list/"
    static INVENTORY_ACTIVE_INVENTORY_BULK_POST = "lab/drug/list/status/"
    static INVENTORY_NEW_DRUG_GET = 'lab/new/product/registry/'
    static INVENTORY_NEW_DRUG_PUT = 'lab/new/product/registry/'
    static INVENTORY_STOCK_EXPIRY_GET = "lab/report/expiry/"
    static INVENTORY_NO_MOVEMENT_GET = "lab/no/movement/product/"
    /**Reports - Stock Report ----- start */
    static PHARMACY_REPORT_STOCK_REPORT = "administrator/pharmacy/reports/stock_report/"
    static PHARMACY_REPORT_MIS_REPORT = "administrator/pharmacy/reports/stock_mis/"
    static PHARMACY_REPORT_Lowstock = "administrator/pharmacy/reports/stock_lowstock/"
    static PHARMACY_REPORT_Expiry_Stock = "administrator/pharmacy/reports/stock_expiry/"
    static PHARMACY_REPORT_SlowMovement_Stock = "administrator/pharmacy/reports/stock_slowmovement/"
    static PHARMACY_REPORT_NoMovement_Stock = "administrator/pharmacy/reports/stock_nomovement/"
    /**Reports - Stock Report ----- end */
    /**Pharmacy Management API ---- end*/

    /**Laboratory API**/
    static LAB_VENDOR = "lab/vendor/detail/"
    //Doctor token creation
    static DOCTOR_TOKEN_NUMBER = "fo/latest/token/number/"
    // Lab Billing
    static BILLING_REFERRED_DOCTOR = "lab/billing/referred-by/"
    static BILLING_REFERED_SOURCE = "fo/referrel-list/"
    static LAB_COMPLETE_BILL_POST = "lab/bill/complete/new/"
    static LAB_PARTIAL_BILL_POST = "lab/partial/bill/new/"
    static LAB_PARTIAL_BILL_LIST = "lab/partial/bill/list/"
    static LAB_PATINET_STATUS = "lab/result/summary/"
    static LAB_PREVIOUS_REPORT = "lab/report/previous/"
    static LAB_PATENT_SPECIMAN_COLLECTED = "lab/speciman/collection/"
    static LAB_PRE_SPECIMAN_COLLECTED = "lab/pre/specimen/collection/"
    static LAB_POST_SPECIMAN_COLLECTED = "lab/post/specimen/collection/"
    static LAB_TEST_CONSUMABLE = "lab/test/consumable/"
    static LAB_HOME_SEARCH = "api/search/"
    static LAB_CREATE_PATIENT_DETAILS = "lab/create/patient/profile/"
    static LAB_SAVED_BILL_LIST = "lab/partial/bill/list/"
    static LAB_SAVED_BILL_DELETE = "lab/bill/cancel/new/"
    static LAB_PARTIAL_BILLING = "lab/partial/billing/"
    static LAB_PATIENT_DETAILS = "lab/patient/details/"
    static LAB_PRODUCT_DETAILS = "lab/new/product/registry/"
    static LIST_VENDOR = "lab/vendors/list/"
    static LAB_TEST_CONFIG_GET = "lab/test/config/"
    static LIST_VENDOR = "lab/vendor/detail/search/"
    static LAB_PATIENT_TRANSMIT_GET = "lab/transmitted/test/search/"
    static LAB_MULTIBILL_TRANSMIT_GET = "fo/overall/transmitted-data/"
    static LAB_PATIENT_TRANSMIT_SEARCH = "lab/home/patient/search/"
    static LAB_TEST_REPORT_PRINT = "lab/bill/report/"
    static LAB_TAT_REPORT = "lab/tat/report/"
    static LAB_OUTSOURCE_LIST = "lab/outsource-list/"
    static LAB_NOTIFICATION_GET = 'lab/home/notification/'

    static REPORTS_OUTSOURCE_GET = "lab/report/outsource/"
    static LAB_CREATE_BILL_PARTIAL_PRINT = "lab/partial/bill/new/"
    static LAB_CREATE_BILL_COMPLETED_PRINT = "lab/bill/complete/new/"

    static LAB_CLINIC_LIST_GET = "lab/clinic/data/"

    static LAB_GROUP_BASED_LIST_GET = "lab/group/report/"
    static LAB_TEST_BASED_LIST_GET = "lab/test/report/"

    static LAB_PATINET_TEST_REPORT = "lab/result/completed/"

    //Result
    static LAB_PATIENT_RESULT_GET = "lab/test/result/"
    static LAB_PATIENT_RESULT_POST = "lab/test/result/"
    static LAB_PATIENT_RESULT_PUT = 'lab/test/result/'
    static LAB_PATIENT_BACTERIA_GET = 'lab/bacteria/list/'
    static LAB_PATIENT_ANTI_BACTERIA_GET = 'lab/anti-bacteria/list/'
    static LAB_PATIENT_OUTSOURCE_PATCH = "lab/test/result/"
    static LAB_PATIENT_OUTSOURCE_GET = "lab/test/result/"
    static LAB_PATIENT_RESULT_DELETE = "lab/test/result/"
    static LAB_PATIENT_RESULT_PRINT = "lab/test/report/print/"
    static LAB_PATIENT_RESULT_PRINT_HISTORY = "lab/test/report/history/print/"
    static LAB_RESULT_SIGNATURE = "lab/sign/details/"
    static LAB_FOR_TECHNICIANS = "lab/test/technician/"
    static LAB_FOR_TECHNICIANS_NEW = "lab/test/technician/new/"
    static LAB_CENSUS_REPORT = "lab/test/census/report"

    //Lab purchase 
    static LAB_VENDOR_DETAIL = "lab/vendor/detail/list/"  //INDIVIDUAL VENDOR DETAILS
    static LAB_PO_BRAND_SUGGESTION = "lab/po/brand/search/"
    static LAB_PO_PRODUCTDETAILS = "lab/po/brand/detail/"
    static LAB_PURCHASEORDER_LIST = "lab/purchase/order/list/"
    static LAB_WANTED_LIST = "lab/wanted/stock/list/"
    static LAB_WANTED_LIST_POST = "lab/move/to/order/"
    static LAB_ORDER_LIST = "lab/move/to/order/"
    static LAB_CONFIRM_ORDER_LIST = "lab/order/detail/" //GET
    static LAB_CONFIRM_PLACE_ORDER = "lab/purchase/order/"
    static LAB_DIRECT_PO = "lab/product/direct/po/"    // post
    static LAB_TEST_GROUP_GET = "lab/test/labset/"
    static LAB_REFERRED_DOCTOR = "lab/referral/doctor/";
    static LAB_CANCEL_BILL = "lab/bill/cancel/new/"
    static LAB_OUTSOURCE_CONFIG = "lab/outsource/config/"
    static LAB_VENDOR_PAYMENT_LIST = "lab/vendor/payment/"
    static LAB_VENDOR_PAYMENT_MONTH = "lab/vendor/payment/month/"
    static LAB_VENDOR_HISTORY = "lab/vendor/payment/history/"
    static LAB_OUTSOURCE_CONFIG = "lab/outsource/config/";
    static LAB_PATIENT_REPORT = "lab/patient/report/";
    static LAB_DOCTOR_REPORT = "lab/doctor/report/";
    static LAB_BILL_REPORT = "lab/bill/report/";
    static LAB_OUTSOURCE_MAPPING = "lab/outsource/mapping/"
    static LAB_SEARCH_PATIENT = "lab/patient/search/"
    static LAB_CONSUMABLES_LIST_GET = "lab/consumable/search/"
    static LAB_CONSUMABLES_GET = "lab/consumable/service/map/"
    static LAB_DATA_FROM_PURCHASE = "lab/po/stock/items/"
    static LAB_ADD_TO_STOCK = "lab/product/add/po/"
    static LAB_PATIENT_DETAILS_GET = "lab/patient/demographics/"
    static LAB_PATIENT_REPORT_PRINT = "lab/patient/report/"
    static LAB_DOCTOR_REPORT_PRINT = "lab/doctor/report/"
    static LAB_BILL_REPORT_PRINT = "lab/bill/report/"
    static LAB_PATIENT_OUTSOURCE_PRINT = "lab/report/outsource/"
    static LAB_CHECK_BATCH_NO = "lab/po/batch/list/"
    static LAB_PREVIOUS_PRICE = "lab/previous/prize/detail/"
    static LAB_CULTURE_TEST_CONFIG = "lab/culture/"
    static LAB_CENSUS_REPORT_OLD = "lab/census/report/"
    static LAB_ANALYSER_MASTER = "lab/analyser/master/"
    static LAB_ANTIBIOTIC_MASTER = "lab/antibioticmaster/"
    static LAB_ORGANISM_MASTER = "lab/organismmaster/"
    static LAB_ORGANISM_VS_ANTIBIO_MASTER = "lab/organism/vs/antibiotic/"
    static LAB_REPORT_PRINT_CONFIG = "lab/report/print-configuration/"
    static LAB_REPORT_PRINT_CONFIG_PREVIEW = "lab/test/report/print/"

    //FO - OP Service Configuration API
    static FO_CONFIG_OPSRCNAME = "fo/service/config/new/"
    static FO_CONFIG_OPSRCTEMPLATE = "fo/template/"
    static FO_CONFIG_OPSPECIALIZATION = "fo/specialization/"
    static VITALS_CONFIGURATION = "fo/vital/config/"
    static FO_CONFIG_OPDOCTORNAME = "fo/doctor/name/"
    static FO_CONFIG_OPAPPOINTMENT = "fo/appointment/type/"
    static FO_CONFIG_OPBILLPREFIX = "fo/billprefix/config/"  // yet to come
    static FO_CONFIG_OPTOKENPREFIX = "fo/prefix/config/"
    static FO_CONFIG_OPPATIENTTAG = "fo/patient/tag/"
    static FO_CONFIG_OPSRCNAMEANDTYPE = "fo/search/service/"
    static FO_CONFIG_OPSPLGET = "fo/specilation/type/"
    static FO_POV_LIST = "fo/pov/"
    static FO_POV_LIST_MASTERS = "fo/clinic/purpose-of-visit/"
    static SCHEDULE_POST_API = "fo/doctor/schedule/"
    static SCHEDULE_GET_API = "fo/doctor/schedule/list/"
    static SCHEDULE_TIME_GET = "doctorv4/slot/list/"
    static FO_CORPORATE_SERVICE_CONFIG = "fo/corporate/service/config/"
    static FO_NEW_CORPORATE_SERVICE_CONFIG = "billing/corporate/service/"
    // static SCHEDULE_TIME_GET = "doctor/schedule/time/"
    //FO - Corporate Configuration API
    static FO_CONFIG_CORPORATE = "fo/corporate/detail/";
    //FO - Referral Configuration API
    static FO_CONFIG_REF_SOURCE = "fo/referral/source/"
    static FO_CONFIG_REF_DOCTOR = "fo/referral/doctor/"
    static FO_CONFIG_REF_Config = "fo/referral/staff/"
    //FO - User Configuration
    static FO_CONFIG_USER_CONFIGURATION = 'fo/user/list/config/'
    //FO - Home screen API
    static FO_HOME_OP = "fo/appointment/list/"
    static FO_HOME_OP_STATUS = "fo/appointment/status/update/"
    static FO_HOME_OP_POV_UPDATE = "fo/appointment/update/pov/"
    //FO - Get Selected Modules Data
    static MODULES_DATA_GET = 'auth/user/token/'
    //FO - Patient Details
    static FO_DOCTOR_VISIT_REPORT = "fo/visit/report/"
    static FO_TEST_REPORT = "fo/test/report/"
    static FO_TEST_REPORT_DELETE = "doctorv4/patient/test-reports/upload/"

    //FO - Billing Transaction API
    static OVERALL_BILLS_GET = "fo/overall/billing/"
    static CREDIT_BILLS_GET = "fo/credit/report/new/"
    static ORDER_BILLS_GET = "billing/reports/order/list/"
    static COMPLETE_BILLS_GET = "fo/complete/billing/"
    static DAY_END_STATUS_GET = "fo/dayend/bill/report/"
    static DAY_END_STATUS_Filter = "doctor/billing/transaction/"
    static DAY_END_USER_DETAIL_GET = "fo/user/list/config/"
    static FO_ADVANCE_DETAIL = 'fo/advance/detailed/'
    static RADIOLOGY_PRINT = 'radiology/create/bill/'
    static GET_ADVANCE_ADDED = 'pharmacy/advance-added/report/'

    //FO - Reports
    static FO_REPORTS_SERVICE_OVERVIEW = "fo/service/overview/"
    static FO_REPORTS_CONSULT_WISE = "fo/consultation/report/"
    static LAB_CONSULTANT_WISE_REPORT = "lab/consultation/wise/lab/report/"
    static RAD_CONSULTANT_WISE_REPORT = "radiology/consultation/rad/wise/report/"
    static FO_REPORTS_SERVICE_DETAILED = "fo/service/detailed/"
    static FO_REPORTS_IP_SERVICE_OVERVIEW = "ip/report/service/overview/"
    static FO_REPORTS_IP_SERVICE_DETAILED = "ip/report/service/detailed/"
    static FO_REPORTS_IP_LEGER_REPORT = "ip/leger/report/view/"
    static FO_GST_REPORT = "fo/gst-report/new/"

    static FO_REPORTS_CORPORATE_PATIENT = "fo/corporate/patient/report/"
    static FO_REPORTS_CORPORATE_PAYMENT = "fo/corporate/summary/report/"
    static LAB_INSURANCE_REPORT = "lab/receipt/insurance_report/"
    static FO_REPORTS_INSURANCE_PATIENT = "ip/insurance/patient/report/"

    static FO_REPORTS_APPOINTMENT_PATIENT = "fo/patient/appointment/report/"
    static FO_COUNSELLOR_GET = "fo/counsellor/list/"
    static FO_REPORTS_COUNSELLOR_SURGERY = "fo/counsellor-surgery/report/"
    static FO_REPORTS_APPOINTMENT_DOCTOR = "fo/doctor/appointment/report/"
    static FO_REPORTS_APPOINTMENT_SPECIALIZATION = "fo/speciality/appointment/report/"
    static FO_REPORTS_APPOINTMENT_TYPE = "fo/appointment/type/report/"
    static FO_REPORTS_REQUEST_APPOINTMENT = "fo/appointment/request/report/"

    static FO_REPORTS_DEMOGRAPHICS = "fo/patient/demographic/report/"

    static FO_REPORTS_REFERRAL_DOCTOR = "fo/referral/doctor/report/"
    static FO_REPORTS_REFERRAL_SOURCE = "fo/referral/source/report/"
    static FO_REPORTS_REFERRAL_VALUE = "ip/consultation/report-other/"
    static FO_REPORTS_REFERRAl_DETAIL = "fo/referral/detail/"
    static FO_REPORTS_REFERRAL_COUNT = "fo/referral/count/"
    static FO_REPORTS_REFERRAL_PATIENT_COUNT = 'fo/referral/patient/count/report/'

    static FO_REPORTS_POST = "fo/new/report/request/"
    static FO_REPORTS_IPADMISSIION = 'ip/report/ip-admission/list/'
    static FO_REPORTS_IP_DISCHARGE = 'ip/report/ip-discharge/list/'
    static FO_REPORTS_CONCESSION = "fo/concession/report/"
    static FO_REPORT_CREDIT_ADJUSTED_REPORTS = "fo/credit/settlement/"

    //Accounts Reports
    static FO_REPORTS_ACCOUNTS_CONCESSION = "accounts/concession/task/"
    static FO_REP_CRED_SERVICE = "accounts/credit/service/report/task/"
    static FO_REPORTS_ACCOUNTS_DOCTORSHARE = "accounts/doctor/share/report/task/"
    static FO_REPORTS_ACCOUNTS_CREDITSETTLEMENTREPORT = "accounts/credit/settlement/report/task/"

    //FO - Custom Config
    static CUSTOM_CONFIG = "fo/custom-config/"
    static CUSTOM_BARCODE_CONFIG = "fo/custom-barcode-config/"
    static FO_OPTOMETRIST_DOCTOR_MAP = "fo/doctor-optometrist/link/"
    static IP_LABEL_LAYOUT_CONFIG = "fo/ip-label/print-configuration/"
    //FO - Nurse Notes
    static FO_NURSE_NOTES = "fo/patient/vital/"
    static FO_STAFF_LIST = "fo/staff/list/"
    static FO_OPTOMETRIST_LIST = "fo/optometrist/list/"
    static FO_INSURANCE_LIST = "fo/insurance/list/"
    static FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT = "fo/patient/outstanding/visits/"
    //FO - IP Service Configuration
    static FO_CONFIG_IPSRCNAME = "ip/service/configuration/"
    static FO_CONFIG_IPSRCPACKAGE = "ip/package/"
    static FO_CONFIG_IPSRCHISTORY = "ip/service/history/"
    // IP - Room Configurations
    static HOSPITAL_CONFIG = "ip/hospital/config/"
    static WARD_CONFIG = "ip/ward/config/"
    static BED_CONFIG = "ip/bed/config/"
    static USER_ROOM_TYPE = "ip/room/type/"
    static HISTORY_DATA = "ip/history/data/"
    static BED_SELECT = "ip/bed/avail/detail/"
    static BED_AVAIL = "ip/report/beds/"

    //Lab
    static LAB_METHOD_LIST = "lab/test/methods/"
    static LAB_MATERIAL_TYPE = "lab/material/Type/list/"
    static LAB_PRODUCT_TYPE = "lab/product/type/list/"
    static LAB_PRODUCT_UNIT = "lab/product/unit/list/"
    static LAB_SMS_POST = "lab/bill/sms/"

    // IP Admission Create
    static IP_PATIENT_CREATE = "ip/patient/create/"
    static IP_ADMISSION_DETAILS = "ip/admission/create/"
    static IP_ADVANCE_PAYMENT = "ip/advance/payment/"


    static IP_SERVICE_BILL_POST = 'ip/service/billing/'
    static IP_PATIENT_DETAILS = "ip/patientheader/"
    static IP_PATIENT_DETAILS_NEW = "ip/patientheader/new/"
    static GET_CORPORATE_CLAIM_DETAILS = "fo/corporate/claim-detail/"
    static GET_OP_CREDIT_DETAILS = "fo/op/patient/credit/details/"

    static LAB_E_SIGNATURE_CONFIG = "lab/esign/"

    static LAB_COMPLETED_TEST = "lab/test/completed/"
    //FO IP Home Patient Details

    static FO_PATIENT_SERVICE_RECEIPT = "ip/patientdetails/"
    static FO_PATIENT_ADMISSION = "ip/admissondetails/"
    static FO_PATIENT_LABORATORY = "ip/testtransmit/"
    static FO_PATIENT_ROOM_CHANGE = "ip/roomchange/"
    static FO_PATIENT_DETAILS = "ip/patientheader/"
    static FO_PATIENT_DETAILS_NEW = "ip/patientheader/new/"
    static IP_RECEIVE_PAYMENT_GET = "ip/receive/payment/"
    static IP_SAFETY_DEPOSIT_RECEIVE_PAYMENT = "ip/safety-deposit/details/"
    static IP_REFUND_PAYMENT_POST = "ip/refund/payment/"
    static FO_PATIENT_DETAILS_IP_ACTION = "ip/action/update/"
    static IP_RESERVATION_PAYMENT = "ip/reserved/receipt-detail/"
    //IP Discharge Summary Config
    static DIS_SUM_LAYOUT = "ip/discharge/summery/"
    static SUR_NOTES_LAYOUT = "ip/surgery/notes/"
    // Fo Appointment Create
    static FO_CREATE_APPOINTMENT = "fo/patient/appoinment/"
    static OP_PATIENT_DEMO_UPDATE = "op/patient/update/"
    static FO_PATIENT_SEARCH = "fo/patient/search/"
    // Fo Ip Home
    static FO_IP_HOME = "ip/home/ipappoinment/"
    static FO_IP_HOME_STATUS = "ip/home/ipappoinment/new/"
    //FO IP Template Config 
    static IP_TEMPLATE_DIS_SUM = "ip/discharge/summary/template/"
    static GET_ICD_CODE = "ip/icdcode/search/"
    static IP_TEMPLATE_SUR_NOTE = "ip/surgery/notes/template/"

    //FO - Demographics config
    static FODemographicsLayout = 'fo/field/order/'

    //Fo - Sms Configuration 
    static FO_SMS_REQUEST = "fo/sms/request/"
    static FO_SMS_CONFIG = "fo/sms/configuration/"
    static FO_SMS_CONFIG_ALERT_REMOVE = "fo/ignore/sms-threshold/"

    //FO - Patient Create
    static FO_PATIENT_CREATE = 'fo/patient/create/'
    static FO_PATIENT_UPDATE = 'fo/patient/update/'
    static FO_PATIENT_APPOINTMENT = 'fo/patient/appoinment/'
    static FO_PATIENT_RESERVATION = 'ip/reserved/ward-detail/'
    // Fo Ip Home
    static GET_RADIOLOGY_LIST = "radiology/clinic/linked/radiology/"
    static FO_PATIEMT_BILLING = "fo/billing/invoice/"
    static FACE_RECOG_SEARCH = "fo/patient/face/search/"
    static FO_APPOINT_REQUESTS = "fo/appointment/request/list/"

    static FACE_RECOG_SEARCH = "fo/patient/face/search/"

    static IP_ROOM_CHANGE = "ip/room/change/"
    static IP_ROOM_CHANGE_POST = 'ip/room/create/'
    static IP_ROOM_CHANGE_NEW = "ip/room/change/new/"

    static IP_DIS_SUM_TEM = "ip/discharge/layout/template/"
    static IP_DIS_SUM_POST = "ip/discharge/summary/"
    static IP_DIS_SUM_COPY_DATA = "ip/dischage-summary/copy/"

    // IP Patient Doctor Notes
    static IP_DOCNOTES_SYMPTOMS = 'ip/symptoms/'
    static IP_DOCNOTES_EXAMINATION = 'ip/examinations/'
    static IP_DOCNOTES_DIAGNOSIS = 'ip/diagnosis/'
    static IP_DOCNOTES_PROVISIONAL_DIAG = 'ip/diagnosisnotes/'
    static IP_PREVIOUS_TEST_RECORDS = 'ip/discharge/summary/test-reports/'
    static IP_CLINICNOTES_HISTORY = "ip/clinicnotes/history/"
    static IP_DOCNOTES_SYMPTOMS_SUGGEST = "ip/symptoms/search/"
    static IP_DOCNOTES_SYMPTOMS_FREQUENT = "ip/frequent/symptoms/"
    static IP_DOCNOTES_EXAMINATION_SUGGEST = "ip/examinations/search/"
    static IP_DOCNOTES_EXAMINATION_FREQUENT = "ip/frequent/examinations/"
    static IP_DOCNOTES_DIAGNOSIS_FREQUENT = "ip/frequent/icd/diagnosis/"
    static IP_DOCNOTES_NURSE_ASSESSMENTS = "ip/nurse/assesment/"

    // FO IP MEDICATION AND LAB 
    static IP_MEDICATION_GET = "ip/medications/"
    static IP_LAB_GET = "ip/inpatient/labbilling/"
    static IP_MEDICATION_TEMPLATE_GET = "ip/medication/template/"

    //FO IP Clinical Notes
    static FO_IP_CLINICAL_NOTES_VITAL = 'ip/inpatient/vitals/'
    static IP_SUR_NOTE_TEM = "ip/surgery/layout/template/"
    static IP_SN_CREATE = "ip/surgery/notes/create/"
    static FO_IP_CLINICAL_NURSE_NOTES = "ip/nursenotes/"
    static FO_IP_HISTORY = "ip/clinicnotes/history/"
    static FO_IP_PHARMALIST_GET = "ip/pharmacy/list/"
    static FO_IP_BRANDNAMELIST_GET = "ip/medication/drug/search/"
    static FO_IP_BRANDDETAILS_GET = "ip/medication/drug/detail/"
    static FO_IP_FREQUENTDRUG = "ip/frequent/medications/"
    static FO_IP_LABLIST = "ip/lab/list/"
    static FO_IP_LABTESTSET = "ip/lab/test/set/"
    static IP_PAIN_CHART = "ip/painchart/"
    static FO_IP_DISCHARGE_SUMMARY_RADTEST = "ip/discharge/summery/radtest/"
    static FO_IP_DISCHARGE_SUMMARY_RADTEST_NEW = "ip/discharge/summery/radtest/new/"
    static FO_IP_DISCHARGE_SUMMARY_INVESTTEST_NEW = "ip/discharge/summery/investigationtest/new/"
    static TPA_List = "ip/tpa/list/"



    static FO_GET_APPOINMENT_DETAILS = "fo/appointment/details/"
    static FO_GET_IP_ADMISSION_DETAILS = "ip/admission/details/"
    static OP_INVOICE_PRINT = "fo/invoice/print/"
    static IP_RECEIVE_PAYMENT_PRINT = "ip/final/bill/print/"
    static IP_INVOICE_PRINT = "ip/bill/print/"
    static FO_PATIENT_APPOINTMENT_DETAILS = "fo/appointment/details/"
    static FO_PATIENT_APPOINTMENT_SAVED_GET = "fo/patient/appointment/saved/bill/"
    static FO_PATIENT_APPOINTMENT_COMPLETED_GET = "fo/patient/complete/bill/"
    static FO_PATIENT_BILL_DETAILS_GET = "fo/patient/bill/"
    static FO_PATIENT_COUNT_DETAILS_GET = "fo/appointment/status-count/"
    // Print Config
    static PRINT_CONFIG = "core/printconfig/"
    static PRINT_HISTORY = "core/printconfig/history/"
    //Bill Layout Config
    static BILL_LAYOUT_CONFIG = "fo/billing/layout/"
    // Bill Report 
    static RECEIPT_REPORT = "fo/recept/billing/"
    //User Access
    static USER_ACCESS_CONFIGURATION = "fo/user/access/"
    static USER_ACCESS_ROLE_GET = "fo/login/role/"
    static USER_ACCESS_GET_LIST = "fo/user/access/list/"
    static USER_ACCESS_GET_MODULES = "fo/lincked/modulelist/"
    static USER_ACCESS_APPROVER_LIST = "billing/discount/"
    static USER_ACCESS_ADD_APPROVER = "billing/checker/"
    static USER_ACCESS_SPECIFIC_LIST = "billing/user/access-list/"
    static REMOVE_USER_ACCESS = "billing/remove-approver/"
    // Admission history 
    static ADMISSION_HISTORY_GET = "fo/appointment/history/"
    static AUTOBILLING_GET = "fo/hospital/config/"
    static IP_AUTOBILLING_GET = "ip/ipauto-billing/"

    //pharmacy invioce print
    static PHARMACY_INVOICE_PRINT = "pharmacy/billing/"
    static LAB_PARTIAL_BILLS = "lab/partial/bill/new/"
    // static LAB_COMPLETED_BILLS = "lab/bill/complete/new/"

    //IP HOME BILL DETAILED PRINT
    static IP_PATIENT_BILL_DETAILED_PRINT = "ip/detail/bill/print/"
    static FO_SURGERY_REPORT = 'doctorv4/patient/surgery_report/'

    static IP_PATIENT_DISCHARGE_SLIP = "ip/dischage-summary/slip/"

    // Optical CRM Sales Report
    static OPTICAL_CRM_CUS_DETAILS = "optical-crm/customer-detail/"
    // Optometrist Report
    static GET_OPTOMETRIST_DETAILS = "fo/optometrist/appoitment/report/"
    static GET_OPTOMETRIST_NAME_LIST = "doctor/clinic/optometrist/list/"

    //OPT Addendum
    static GET_ADDENDUM_LOG = "doctorv4/addendum-notes/"

    //Prescription Report
    static GET_PRESCRIPTION_REPORT_DATA = "fo/prescription/report/"

    //Doctor Notes,Op card and prescription Print
    static OP_DOCTOR_VISIT_REPORT_PRINT = "fo/doctor/notes/print/"
    static OP_DOCTOR_PRECSCRIPTION_PRINT = "fo/medication/print/"
    static OP_CARD_PRINT = "fo/barcode/print/"
    static OP_CUSTOMIZED_CARD_PRINT = "fo/custom-barcode/print/"
    static OP_PATIENT_DATA_PRINT = "fo/op/patient/data/"
    static FO_APPINMENT_PRIENT = "fo/appointment/list/print/"
    static FO_APPINMENT_LIST_EXPORT = "fo/appointment/list/export/"

    //Ip Barcode Label Print
    static IP_BARCODE_PRINT = "ip/label/print/"
    static COMMON_BARCODE_PRINT = "fo/patient/label/print/"
    static IP_DISCHARGE_SUMMARY_TEST = "ip/inpatient/discharge/summery/labtest/"
    static IP_LABEL_PRINT = "fo/ip-label/"

    //Ip Patient Admission Print
    static IP_PATIENT_ADMISSION_PRINT = "ip/ipadmission/print/"
    static IP_APP_PRINT = "ip/admission/list/print/"
    static OP_AUTO_BILLING = "fo/auto/billing/new/"
    static IP_DIS_SUM_PRINT = "ip/discharge/summary/"

    static IP_APPROX_AMOUNT = "ip/bill-value/"
    static FO_RECEIPT_BILL = "fo/patient/receipt/bill/" // fo receipt bill
    static LAB_RECEIVE_PAYMENT = "lab/receive/payment/"

    static OP_PATIENT_CREDIT_BILL_POST = "fo/receive/payment/"

    static LAB_STATUS_AND_TEST_REPORT_AMOUNT_GET = "lab/admission/bill/"
    static LAB_RECEIPT_REPORT = "lab/receipt/report/"

    static DOCTOR_NOTES_PRINT = "doctorv4/print/visit-report/"
    static OPT_PATIENT_DOCTOR_NOTES_PRINT = "doctor/opt/visit/report/"
    static PRINT_PRESCRIPTION = "doctorv4/print/prescription/"
    static OPT_PRESCRIPTION_PRINT = "doctor/opt/medication/print/"

    static SUMMERY_BILL_REPORT = "fo/consolidate/bill/summary/"
    static SUR_NOTE_PRINT = "ip/surgery/notes/print/"
    static RECEIPT_INDIV_PRINT = "ip/receipt/print/"
    static OP_DETAILED_BILL_PRINT = "fo/detail/invoice/print/"
    static OP_SUMMARY_BILL_PRINT = "fo/summary/bill/report/"
    static OP_PRES_TEMPLATE = "fo/prescription/sheet/"

    static IP_PATIENT_INDIVIDUAL_SAVED_BILL = "ip/saved/bill/list/"
    static IP_PATIENT_INDIVIDUAL_BILLS = "ip/bill/list/"
    static IP_PATIENT_INDIVIDUAL_RECEIPT_Bill = "ip/receipt/bill/list/"
    static IP_ADMISSION_BILL_SUMMARY_PRINT = "ip/summary/bill/detailed/print/"
    static IP_ADMISSION_BILL_APPROX_PRINT = "ip/approx/bill/print/"
    static IP_PATIENT_DATA_PRINT = "ip/patient/data/"
    //Cancel Bill

    static OP_CANCEL_BILL = "fo/cancel/bill/"
    static IP_CANCEL_BILL = "ip/cancel/bill/"
    static LAB_CANCEL_BILL_REFUND = "lab/cancel/bill/"

    static IV_IM_TRACK = "ip/ivim/chart/"

    // Corporate Billing
    static GET_PATIENT_BILLING_DEATILS = "fo/corporate/ip/bills/";
    static CORPORATE_BILLING = "core/employer/bill/";
    static CORP_LIST_GET = "core/employer/"
    static DOCTOR_SHARE_REPORT = "fo/hospital/doctor/share/"
    static FO_REPORTS_TAT = "fo/tat/report/"
    static FO_REPORTS_PURPOSEOFVISIT = "fo/patient/pov/view/"
    static OP_NURSE_NOTES = "fo/nurse-notes/"
    static OP_NURSE_HIS = "fo/nurse-notes/history/"
    static FO_RESERVATION_BEDSLT = "ip/bed/reservation/detail/"
    static FO_RESERVATION_GET = "ip/room/reservation/"
    static FO_REPORTS_REASON_DIAGNOSIS = "fo/complaints/diagnosis/view/"
    static IP_COMPLAINTS_DATASET = "ip/reason/"
    static IP_COMPLAINTS_DATASET_MASTERS = "ip/clinic/reason/"
    static FO_REPORTS_TAT_DETAILED_VIEW = "fo/tat/timereport/"

    static MEDICAL_RECORD_PRINT = "fo/medical/record/"
    static IP_ATTENDER_CHECKOUT = "ip/attender/checkout/"
    static IP_ATTENDER_CHECKOUT_NEW = "ip/attender/checkout/new/"
    static FO_RESERVATION_FILTER_GET = "ip/patient/attender/reservation/"
    static FO_RESERVATION_COUNT_LIST = "ip/ward/room/availability/count/"

    // Ip Estimation 
    static IP_ESTIMATE_BILL_GET = "ip/estimate/bill/"
    static IP_ESTIMATE_LIST_GET = "ip/estimate/list/"
    static EXPENSE_CATEGORY_GET = "doctor/expense/category/"
    static EXPENSE_BILL_GET = "doctor/expense/bill/report/"

    // fo billing transaction new reports
    static FO_RECEIPT_DETAIL = 'fo/receipt/detailed/'

    //PHARMACY ===> URL'S STARTS
    // Pharmacy Sales Report
    static PHARMA_SALES_OVERVIEW_REPORT_GET = 'pharmacy/reports/sales/overview/'
    static PHARMA_SALES_DETAILED_REPORT_GET = 'pharmacy/reports/sales/detailed/'
    static PHARMA_SALES_RETURN_REPORT_GET = 'pharmacy/sales/return/report/new/'
    static PHARMA_SALES_MONTHLY_REPORT_GET = 'pharmacy/reports/sales/monthly/'
    static PHARMA_DAY_END_REPORT_GET = 'pharmacy/reports/sales/day-end/'
    static PHARMA_PRODUCT_WISE_SALE = 'pharmacy/product/sales/report/'
    static PHARMA_RETURN_TAX_WISE_SALES = 'pharmacy/sales/return/tax/report/'
    static SALES_RETURN_HSN_CODE_WISE = 'pharmacy/sales/return/hsn/report/'
    static SALES_RETURN_HSN_CODE_RATE_WISE = 'pharmacy/sales/return/hsn/tax/report/'
    static SALES_REPORTS_PROFITANALYSIS = 'pharmacy/profit/analysis/report/'
    static SALES_BILL_TAX_WISE = 'pharmacy/reports/sales/invoice/tax/'
    static PHARMA_USER_SALES_PERFORMANCE = 'pharmacy/user/performance/'
    static SALES_RETURN_HSN_DOSAGE_WISE = 'pharmacy/sales/return/hsn/dosage_type/report/'

    //Purchase Report
    static PHARMA_PURCHASE_OVERVIEW_REPORT_GET = 'pharmacy/reports/purchase/overview/'
    static PHARMA_PURCHASE_DETAILED_REPORT_GET = 'pharmacy/reports/purchase/detailed/'
    static PHARMA_THREE_MONTH_REPORT_GET = 'pharmacy/threemonth/report/'
    static PHARMA_PURCHASE_RETURN_REPORT_GET = 'pharmacy/reports/purchase-return/'
    static PHARMA_PURCHASE_MONTHLY_REPORT_GET = 'pharmacy/reports/purchase/monthly/'
    static PHARMA_PURCHASE_CONSOLIDATED_REPORT_GET = 'pharmacy/consolidate-report/'
    static PHARMA_PURCHASE_BILL_TAXWISE_GET = 'pharmacy/reports/purchase/invoice/tax/'
    static PHARMA_PURCHASE_BILL_RETURN_TAXWISE_GET = 'pharmacy/reports/purchase/return/invoice/tax/'
    //Pharmacy Inventory Report
    static PHARMA_INVENTORY_STOCK_OVERVIEW_REPORT_GET = 'pharmacy/reports/stock/'
    static PHARMA_INVENTORY_BRAND_GET = 'pharmacy/drugs/auto-complete/'
    static PHARMA_INVENTORY_GENERIC_GET = 'pharmacy/drug-details/'
    static PHARMA_INVENTORY_VENDOR_GET = 'pharmacy/vendor/search/'
    static PHARMA_INVENTORY_MIS_REPORT_GET = 'pharmacy/reports/mis-report/'
    static PHARMA_INVENTORY_EXPIRY_STOCK_REPORT_GET = 'pharmacy/reports/drug-expiry/'
    static PHARMA_INVENTORY_LOW_STOCK_REPORT_GET = 'pharmacy/reorder/threshold/'
    static PHARMA_INVEMTORY_SLOW_MOVEMENT_REPORT_GET = 'pharmacy/slow-movement/'
    static PHARMA_INVENTORY_NO_MOVEMENT_REPORT_GET = 'pharmacy/no-movements/'
    static PHARMA_INVENTORY_STOCK_CORRECTION_REPORT_GET = 'pharmacy/stock_correction/report/'
    static PHARMA_INVENTORY_STOCK_VALUE_REPORT_GET = 'pharmacy/stockvalue/report/'
    static PHARMA_INVENTORY_EDIT_DRUG_POST = 'pharmacy/druglist/update/'
    static PHARMA_STOCK_EDIT_LOG = 'pharmacy/stock-edit-log/'

    //Pharmacy GST Report
    static DAY_HSN_GSTSUMMARY = 'pharmacy/gst/report/new/'

    // Pharmacy billing
    static PHARMA_BILLING_BRAND_SEARCH = 'pharmacy/drugs/search/'
    static PHARMA_BILLING_DRUG_DETAILS_GET = 'v2/pharmacy/billing/drug/details/'
    static PHARMA_RETURN_BILLING_DRUG_DETAILS_GET = 'pharmacy/billing/drugs/'
    static PHARMACY_BULK_RETURN_POST = 'pharmacy/billing/ip/return/'
    static PHARMA_BILLING_RECEIVE_PAYMENT_POST = "pharmacy/billing/new/"
    static PHARMA_BILLING_SAVED_POST = 'v2/pharmacy/partial/billing/'
    static PHARMA_BILLING_CREDIT_POST = 'v2/pharmacy/credit/billing/'
    static PHARMA_RETURN_DRUG_GET = 'pharmacy/return/drugs/search/'
    static PHARMA_SALES_BILL_PRINT = 'pharmacy/sales-bill/print/'
    static PHARMA_BILL_TOKEN_PRINT = 'pharmacy/bill-token/print/'

    // Pharmacy Purchase
    static PURCHASE_WANTED_LIST = "pharmacy/wanted/list/"
    static PURCHASE_ORDER_LIST = "pharmacy/purchase-orders/list/"
    static PURCHASE_ORDER_PO_REQUEST_LIST = "pharmacy/purchase/request/list/"
    static PURCHASE_CONFIRM_ORDER_LIST = "pharmacy/order/list/"
    static PURCHASE_CONFIRMORDER_POPUP = "pharmacy/product/list/order/"
    static PURCHASE_CONFIRMORDER_PRINT = "pharmacy/confirm_order/print/"
    static PURCHASE_PLACEORDER_POST = "pharmacy/purchase-order/"
    static PURCHASE_VENDOR_LIST = "pharmacy/vendors/list/"
    static PURCHASE_VENDOR_PAYMENT = "pharmacy/vendor/payment/transaction/"
    static PURCHASE_VENDOR_PAYMENT_PRINT = "pharmacy/vendor/payment/transaction/detailed/"
    static PURCHASE_VENDOR_MONTHLY = "pharmacy/vendor/payment/transaction/month/"
    static PURCHASE_VENDOR_MONTHLY_POST = "pharmacy/vendor/payment/"
    static PURCHASE_WANTED_LIST_CART = "pharmacy/wanted/list/cart/"
    static PURCHASE_VENDOR_ADD = "pharmacy/vendor/"
    static PURCHASE_BATCHNO_GET = "pharmacy/po-return/drug-detail/"
    static PURCHASE_RETURN_POST = "pharmacy/po-return/new/"
    static PURCHASE_MANUFACTURER_GET = "pharmacy/manufacturer_list/"

    //Inventory
    static LIST_STOCK = "pharmacy/stock-list/"
    static ACTIVE_DRUG_LIST = "pharmacy/new/druglist/"
    static PHARMA_GENERIC_NAME_LIST = "pharmacy/generic_name/registry/"
    static PHARMA_ADD_NEW_DRUG = "pharmacy/drug/registry/"
    static PHARMA_STOCK_DETAILS = "pharmacy/stock-details"
    static PHARMA_STOCK_RETURN_POST = "pharmacy/mark-return/"
    static PHARMA_ACTIVE_DRUG_POST = "pharmacy/new/druglist/status/"

    // Pharmacy Invoice
    static PHARMACY_OVERALL_BILL_LIST = "v2/pharmacy/overall/bill/list/"
    static PHARMACY_CREDIT_BILL_LIST = "v2/pharmacy/credit/billing/transaction/"
    static PHARMACY_PATIENT_CREDIT_BILL = "v2/pharmacy/credit/billing/"
    static PHARMACY_SAVED_BILL_LIST = "pharmacy/saved/bill/new/"
    static PHARMACY_RECEIPT_BILL_LIST = "pharmacy/receipt/bills/"
    static RECEIPT_PHARMACY_PRINT = "pharmacy/receipt/print/"

    // Pharmacy Directpo
    static PURCHASE_BRAND_NAME_GET = "pharmacy/po/drugs/search/"
    static PURCHASE_BATCH_DETAILS_GET = "pharmacy/po/drug-details/"
    static PURCHASE_DRUG_DETAILS_GET = "pharmacy/drug-details/"
    static PURCHASE_BATCH_LIST_POST = "pharmacy/batch/list/"
    static PURCHASE_DIRECT_PO_POST = "v2/pharmacy/direct/po/"
    static PURCHASE_PO_NUMBER_GET = "pharmacy/po-number/get/"
    static PURCHASE_PO_DETAILS_GET = "v2/pharmacy/stock/entry/items/"
    static PURCHASE_ADD_TO_STK_POST = "v2/pharmacy/add/to/stock/"
    static PURCHASE_DC_POST = "pharmacy/dc_entry/"
    static PRESCRIPTION_HOME = "v2/pharmacy/transmitted/prescription/list/"
    static SAVED_BILL_HOME = "v2/pharmacy/partially/saved/bills/list/"
    static IP_RETURN_HOME = "pharmacy/medication/return/list/"
    static IP_REQUEST_HOME = "pharmacy/medication/list/"
    static APPOINTMENT_HOME = "pharmacy/appointments/list/"
    static PURCHASE_PREVIOUS_PRICE_GET = "pharmacy/get/previous-drug-details"
    static IP_ADMISSION_LIST_HOME = "pharmacy/ipadmission/list/"
    static PHARMACY_PO_CANCEL = "pharmacy/purchase/order/cancel/"

    // Pharmacy Internal Store
    static  INTERNALSALES_WANTEDLIST = "v2/pharmacy/all/wanted/list"
    static  INTERNALSALES_WANTEDLISTDetail = "pharmacy/wanted/list"
    static  INTERNALSALES_REQUESTLIST = "v2/pharmacy/store/request/list"
    static  INTERNALSALES_DRUGSTOCK_DETAILS = "v2/pharmacy/store/drug/search/"
    static  INTERNALSALES_SEND_REQUEST_LIST = "v2/pharmacy/store/request/list/"
    static  INTERNALSALES_SALES_REPORT = "v2/pharmacy/internal/sales/report/"
    static  INTERNALSALES_TAX_REPORT = "v2/pharmacy/internal/tax/report/"
    static  INTERNALSALES_INVOICE_REPORT = "v2/pharmacy/invoice/report/"
    static  INTERNALSALES_MONTHWISE_INVOICE_REPORT = "v2/pharmacy/invoice/report/"
    static  INTERNALSALES_PO_RECEIVE = "v2/pharmacy/store/po/receive/"
    

    //Pharmacy Settings
    static PHARMA_STOCK_CORRECTION_LIST = "pharmacy/inventory/stock_adjustment/"
    static PHARMA_DOSAGE_TYPE_LIST = "pharmacy/dosage-types/"
    static PHARMA_CONFIG_SETTINGS = "pharmacy/config/"
    static PHARMA_HEADER_SEARCH = "fo/patient/search/"
    static PHARMA_STOCK_CORRECTION_HISTORY = "pharmacy/inventory/stock_adjustment/history/"
    static PHARMA_USER_CONFIG = "pharmacy/login_user_list/"

    //Pharma Billing
    static PHARMA_DOCTOR_LIST = "pharmacy/billing/doctor/list/"
    static PHARMA_SAVED_BILL_GET = "v2/pharmacy/partial/billing/"
    static PHARMA_PATIENT_DETAILS_GET = "pharmacy/search/patient/"
    static PHARMA_BILLS_GET = "pharmacy/billing/"
    static PHARMA_RETURN_BILL = "pharmacy/bill/return/new/"
    static PHARMA_SAVED_BILL_DELETE = "v2/pharmacy/partially/saved/bill/"
    static PHARMA_PRESCRIPTION_GET = "pharmacy/prescription/"
    static PHARMA_PRESCRIPTION_HISTORY = "v2/pharmacy/invoice/history/"
    static PHARMA_REF_DOCTOR = "pharmacy/referred/doctor/bill/"
    static PHARMA_PATIENT_LIST = "pharmacy/patient/report/"
    static PHARMA_ADD_DOCTOR = "pharmacy/referred/doctor/"
    static PHARMA_HEADER_SEARCH = "pharmacy/search/patient/"
    static PHARMA_GST_SALES = "pharmacy/gst/report/new/"
    static PHARMA_PURCHASE_GST = "pharmacy/purchase/gst/report/new/"
    static PHARMA_DISC_SUGGESTIONS = "pharmacy/discount/reasons/"

    // Sub Location URLs
    static SUBLOC_PATIENT_SEARCH = "sublocation/search/"
    static SUBLOC_DRUG_SEARCH = "sublocation/drug/search/"
    static SUBLOC_BATCH_DETAILS_SEARCH = "sublocation/drug/details/"
    static SUBLOC_BILLING_POST = "sublocation/billing/"
    static SUBLOC_GENERIC_CONSUMP_POST = "sublocation/consumption/"
    static PHARMA_SUB_LOCATION = "pharmacy/sublocation/view/"
    static PHARMA_USER_ACCESS_SUB_LOC = "sublocation/active/list"
    static PHARMA_USER_ACCESS_POST = "sublocation/user/access/"
    static PHARMA_USER_ACCESS_GET = "sublocation/user/access/list/"

    static SUBLOC_FROM_LOCATION_GET = 'sublocation/module-list/'
    static SUBLOC_REQUEST_DRUG_LIST_GET = 'sublocation/drug-list/'
    static SUBLOC_STOCK_TRANSFER = 'sublocation/stock-transfer/'
    static SUBLOC_STOCK_TFR_WANTED_LIST_GET = 'sublocation/wanted-list/'
    static SUBLOC_SAVED_BILLS_GET = 'sublocation/billing/list/'
    static SUBLOC_STOCK_LIST_REPORT_GET = 'sublocation/stock/list/view/'
    static SUBLOC_STOCK_EXPIRY_REPORT_GET = 'sublocation/stock/expiry/view/'
    static SUBLOC_STOCK_RETUEN_REQUEST_GET = 'sublocation/stock-return/'
    static SUBLOC_STOCK_LIST_HISTORY_GET = 'sublocation/stock/correction/history/'
    static SUBLOC_CONSUMPTION_REPORT_GET = 'sublocation/consumption/'
    static SUBLOC_OUTBOUND = 'sublocation/stock-outbound/'
    static SUBLOC_LINE_OF_ITEM = 'sublocation/inbound/stock-line/'
    static SUBLOC_CREDIT_REPORT_GET = 'sublocation/credit/report/'
    static SUBLOC_CREDIT_INDIVIDUAL_REPORT_GET = 'sublocation/credit/report/list/'
    static SUBLOC_STATUS_CHANGE = 'sublocation/request/status/'
    static SUBLOC_TRANSIT_DETAILS = 'sublocation/transit/details/'
    static SUBLOC_LOCATION_DETAILS = 'sublocation/module-list-new/'
    //Lab New Configuration --- API

    static NEW_LAB_AMOUNT_CONFIGURATION_API = 'lab/test-config/'
    static NEW_LAB_RESULT_CONFIGURATION = 'lab/result-config/'
    static NEW_LAB_PACKAGE_CONFIGURATION = 'lab/package/'
    static LAB_TEMPLATE_CONFIGURATION = 'lab/template/'
    static LAB_DEPT_LIST = 'lab/dept/'
    static LAB_ADD_NEW_TEST = 'lab/test/create/'
    static LAB_GRP_EDIT_DELETE = 'lab/group/edit/'

    //Counsellor & OT API
    static GET_COUNSELLOR_APPOINTMENTS = "counsellor/appointments/list/"
    static HOME_GET_CLINIC_DOCTORS = "doctor/clinic/doctors/"
    static COUNSELLOR_RETRANSMIT_POST = "counsellor/retransmit/"
    static GET_OT_APPOINTMENT_LIST = "doctor/ot/appointment/"
    static UPDATE_OT_APPOINTMENT_LIST = "ot/appointment/status/"
    static DOC_OT_REQUEST_GET = 'doctor/ot/appointment/request/'
    static OT_SURGERY_REPORT = 'ot/appointment/report/'
    static OT_BILLING_DRUG_SUGESSION = "ot/drug/bill-suggestion/"
    static OT_BILLING_IOL_DRUG_SUGESSION = "ot/iol/bill-suggestion/"
    static OT_BILLING_POST = "ot/billing/"
    static OT_ROOM_CONFIG = "ot/slot/config/"
    static GET_STOCK_USAGE_LIST = "ot/indent/drugmaster-namelist/"
    static IOL_DRUG_SUGGEST = "ot/iolstockmaster/name/"
    static GET_STOCK_USAGE_BRAND_DETAILS = "ot/indent/drugmaster-details"
    static IOL_MODEL_SUGGEST = "ot/iolstockmaster/details/"
    static GET_STOCK_USAGE_TRANSACTION = "ot/otstockusage/transaction/"
    static STOCK_IOL_USAGE_TRANSACTION = "ot/iol/stockusage/transaction/"
    static STOCK_DRUG_PUT = "ot/otstockusage/"
    static STOCK_DRUG_PUT_IOL = "ot/iol/product_details_search/quantity/"
    static OT_DRUG_LIST_GET = "ot/drug/listing/"
    static OT_IOL_STOCK_LIST = "ot/add-new/iol/"
    static OT_INVENTORY_IOL_TYPE_SUGGESTION = "ot/iol/type-suggestion/"
    static OT_INVENTORY_IOL_NEW_IOL = "ot/iol/product/"
    static GET_HISTORY_LIST = "ot/appointment/history/"
    static GET_PRINT_PREVIEW = "ot/billing/tranaction/list/"
    static GET_OT_CancelledReport = "ot/appointment/report/"
    static OT_IP_REQUESTLIST = "ot/ip-request/list/"
    static OT_SALES_OVERVIEW_REPORT = "ot/sales-overview-report/"
    static OT_SALES_DETAILED_REPORT = "ot/sales-detailed-report"
    static OT_GROUP_FILTER = "ot/group-name-list/"
    static OT_SALES_BILL_TAX_WISE = "ot/sales-bill-taxwise-report/"
    static OT_OVERALL_BILLS_REPORT = "ot/overall/billing/report/"
    static OT_BILL_DATA_VIEW = "ot/bill/data/view/"
    //

    static FO_TELE_APPOINTMENT_REQUEST = "fo/appointment/request/"


    static IP_NEW_SERVICE_CATEGORY_GET = 'ip/service/category/'
    static FO_NEW_OP_SERVICE_CONFIG = 'fo/service/config/new/'
    static IP_NEW_SERVICE_CONFIGURATION = 'ip/service/configuration/'
    static FO_DOCNOTES_PRINT = 'fo/print/clinical-notes/'

    static FO_NEW_OP_SERVICE_CONFIG_CATEGORY_GET = 'fo/service/category/list/new/'
    static IP_SURGERY_NAME_CONFIG = 'ip/surgery/name/'

    static IP_BED_AVAILABLE = "ip/bed/available/"
    static IP_BED_AVAILABLE_STATUS_POST = "ip/bed/maintenance/"

    static IP_DIS_SUM_CATAGORY = "ip/discharge/summary/category/config/"
    static PO_RETURN = 'pharmacy/po/return/'
    static PHRAMCY_GROUP_FILTER = 'pharmacy/group/name/'

    static CREDIT_TYPE_CHANGE = "fo/credit/type/update/"
    //Chart Dashboard URLs
    static CHART_OVERALL_REVENUE = 'fo/dash/overall/revenue/'
    static CHART_OVERALL_PAYMENTS = 'fo/dash/overall/payment/collection/'
    static CHART_OVERALL_CREDIT_AMOUNT = 'fo/dash/credit/amount/'
    static CHART_OVERALL_APPOINTMENT_TYPE_COUNT = 'fo/dash/appointment/type/count/'
    static CHART_OP_SPECIALZATION = 'fo/dash/op/top/specialization/'
    static CHART_OP_TOP_DOCTORS = 'fo/dash/op/top/doctors/'
    static CHART_OP_SERVICES = 'fo/dash/op/service/performance/'
    static CHART_OP_LOCATION_ANALYSIS = 'fo/dash/op/location/analysis/'
    static CHART_IP_SPECIALZATION = 'fo/dash/ip/top/specialization/'
    static CHART_IP_TOP_DOCTORS = 'fo/dash/ip/top/doctors/'
    static CHART_IP_SERVICES = 'fo/dash/ip/service/performance/'
    static CHART_IP_LOCATION_ANALYSIS = 'fo/dash/ip/location/analysis/'
    static CHART_OP_PATIENT_COUNT = 'fo/dash/op/appointment/patient/'

    // Pharmacy Chart Dashboard URLs
    static CHART_PHARMA_VENDOR = 'fo/dash/pharmacy/purchase/value/'
    static CHART_PHARMA_DEMOGRAPHICS = 'fo/dash/pharmacy/demographic/'
    static CHART_PHARMA_TOP_SELLING = 'fo/dash/pharmacy/top/selling/drugs/'
    static CHART_PHARMA_SALE_PURCHASE = 'fo/dash/pharmacy/sales/purchase/report/'
    static CHART_PHARMA_NOMOVEMENT = 'fo/dash/pharmacy/nomovementdrug/'
    static CHART_PHARMA_STOCKEXPIRY = 'fo/dash/pharmacy/expirydrug/'
    static CHART_PHARMA_LOWSTOCK = 'fo/dash/pharmacy/low/stock/drug/'
    static CHART_PHARMA_TOTALDRUG = 'fo/dash/pharmacy/total/drug/'

    // Laboratory Chart Dashboard URLs
    static CHART_LAB_ORDEREDTEST = 'fo/dash/lab/ordered/test/'
    static CHART_LAB_COMPLETEDTEST = 'fo/dash/lab/total/test/'
    static CHART_LAB_DEMOGRAPHICS = 'fo/dash/lab/patient/demographic/'
    static CHART_LAB_MOST_PERFORMING = 'fo/dash/lab/most/least/performing/test/'
    static CHART_LAB_SALE_PURCHASE = 'fo/dash/lab/sales/purchase/report/'
    static CHART_LAB_LOCATION = 'fo/dash/lab/location/analysis/'

    // Radiology Chart Dashboard URLs
    static CHART_RAD_DEMOGRAPHICS = 'fo/dash/radiology/patient/demographic/'
    static CHART_RAD_TESTS = 'fo/dash/radiology/most/least/performing/test/'
    static CHART_RAD_LOCATION = 'fo/dash/radiology/location/analysis/'

    // Forgot password
    static SEND_OTP = 'auth/sendotp/'
    static VERIFY_OTP = 'auth/otp/verify/'
    static RESEND_OTP = 'auth/otp/resend/'
    static FORGOT_PASSWORD = 'auth/forget/password/ '

    // Unlock Admin Account 
    static ACCOUNT_UNLOCK_VERIFY_POST = "auth/unlock/verification/";
    static ACCOUNT_UNLOCK_GENERATE_OTP_POST = "auth/unlock/send-otp/";
    static ACCOUNT_UNLOCK_POST = "auth/unlock/verify-otp/";

    static PHARMA_NO_AND_SLOW_MOVEMENT_REPORT = "pharmacy/no-slow/movements/new/"
    //Payment Mode Update
    static PAYMENT_MODE_UPDATE = 'fo/receipt/payment/type/update/'
    static LAB_PATIENT_GET = 'lab/home/patient/detail/'
    static SPECIMEN_BARCODE_PRINT = 'lab/specimen/collection/barcode/'
    static RESET_PASSWORD = 'auth/reset/password/'


    //DOCTOR MODULE API STARTS =========>
    static DOC_PATIENT_DETAIL_GET = 'doctorv4/patient/detail/'
    static DOC_PATIENT_DOCUMENT_GET = 'doctorv4/patient/doc-upload/'
    static DOC_MEDICAL_HISTORY = 'doctorv4/patient/medical/history/'
    static DOC_MEDICAL_PROBLEM_GET = 'doctorv4/problems/'
    static DOC_HOSPITALIZATION_HISTORY = 'doctorv4/patient/hospital/history/'
    static DOC_HOSPITALIZATION_HISTORY_DELETE = 'doctorv4/delete/hospitalization/history/'
    static DOC_SOCIAL_HISTORY = 'doctorv4/patient/social/history/'
    static DOC_FAMILY_HISTORY = 'doctorv4/patient/family/history/'
    static DOC_FAMILY_HISTORY_DELETE = 'doctorv4/delete/family/history/'
    static DOC_APPOINTMENT_LIST = 'doctorv4/appointment/list/'
    static DOC_OPTHOMETRY_APPOINTMENT_LIST = 'doctor/opt/optometrist/appointments/list/'
    static DOC_CLINIC_LIST_GET = 'doctorv4/clinic/'
    static DOC_OPTHOMETRY_CLINIC_LIST_GET = 'doctor/opt/optometrist/doctors/list/'
    static DOC_PATIENT_SEARCH_GET = 'api/search/'
    static DOC_APPOINTMENT_STATUS = 'doctorv4/appointment/status/'
    static DOC_OPTHOMETRY_APPOINTMENT_STATUS = 'doctor/appointment/status/'
    static DOC_APPOINTMENT_STATUS_UPDATE = 'doctorv4/appointment/status/update/'
    static DOC_DILATION_TIMER_UPDATE = 'doctor/opt/appointment/dilation/'
    static DOC_PATIENT_CREATION = 'doctorv4/patient/create/'
    static DOC_REFERRAL_SOURCE = 'doctorv4/referral/source/'
    static DOC_REFERRAL_DOCTOR = 'fo/referral/doctor/'
    static DOC_PATIENT_APPOINTMENT = 'doctorv4/appointment/create/'
    static DOC_DIABETIC_HISTORY = 'doctorv4/diabetic/history/'
    static DOC_NUTRITION_HISTORY = 'doctorv4/diabetic/nutrition/history/'
    static DOC_PHYSICAL_HISTORY_GET = 'doctorv4/diabetic/physicalactivity/'
    static DOC_PHYSICAL_HISTORY_POST = 'doctorv4/diabetic/physicalactivity/create/update/'
    static DOC_BLOOD_GLUCOSE_HISTORY_POST = 'doctorv4/diabetic/bg/monitoring/create/update/'
    static DOC_BLOOD_GLUCOSE_HISTORY_GET = 'doctorv4/diabetic/bg/monitoring/'
    static DOC_BLOOD_MENSURAL_HISTORY_GET = 'doctorv4/diabetic/menstrual-history/'
    static DOC_DOCTOR_VISIT_REPORT = 'doctorv4/visit/report/'
    static DOC_DOCTOR_CLINIC_LIST_GET = 'doctorv4/clinic/doctors/'
    static DOC_DOCTOR_TEST_REPORT = 'doctorv4/test/report/' // same for collaborative
    static DOC_DOCTOR_TEST_REPORT_POST = 'doctorv4/patient/test-reports/upload/'
    static DOC_PRINT_ORDER_REPORT = 'doctorv4/test/order/'
    static DOC_NUTRITION_CHART = 'doctorv4/meal/plan/'
    static DOC_CHART_HBA1C = 'doctorv4/diabetic/hba1c/chart/'
    static DOC_GLUCOUSE_LOG = 'doctorv4/diabetic/glucose-log/'
    static DOC_BIOTHESOMETRY = 'doctorv4/diabetic/foot_clinic/biothesiometry/'
    static DOC_BRANCHICAL_INDEX_LOG = 'doctorv4/diabetic/foot_clinic/brachial_index/'
    static DOC_COLLAB_HISTORY_REPORT = 'doctorv4/history/report/'
    static DOC_COLLAB_DOCTOR_NOTES_REPORT = 'doctorv4/doctor-notes/report/'
    static DOC_COLLAB_DIS_SUMMARY_REPORT = 'doctorv4/discharge-summary/report/'
    static DOC_COLLAB_SURGERY_NOTES_REPORT = 'doctorv4/surgery-notes/report/'
    static DOC_SPECIALIZATION_LIST = 'doctorv4/business/specialisation-list/'
    static DOC_REGISTRY_DIAGONIS = 'doctorv4/registry/'
    static DOC_DOCTOR_NOTES_SYMPTOMS = 'doctorv4/symptoms/'
    static DOC_DOCTOR_NOTES_ALLERGIES = 'doctorv4/allergy/'
    static DOC_DOCTOR_NOTES_EXAMINATION_GET = 'doctorv4/patient/examination/' //
    static DOC_DOCTOR_NOTES_OLD_PRESCRIPTION = 'doctorv4/old/prescription/' //?patient_id=1271070&appointment_id=1066846
    static DOC_DOCTOR_NOTES_PRESCRIPTION = 'doctorv4/patient/prescription/'
    static DOC_DOCTOR_NOTES_PHARMACY_LIST_GET = 'doctorv4/pharmacy/list/' //?clinic_id=10&suggest=true
    static DOC_DOCTOR_NOTES_PREVIOUS_PRESCRIPTION_APPOINTMENT_DATE_GET = 'doctorv4/patient/prescription/appointment/date/' //'
    static DOC_DOCTOR_NOTES_TEST_GET = 'doctorv4/tests/'
    static DOC_DOCTOR_NOTES_LAB_LIST = 'lab/clinic/linked/model/' //?clinic_id=10'
    static DOC_DOCTOR_NOTES_PLAN_GET = 'doctorv4/procedure/'
    static DOC_DOCTOR_NOTES_ASSESSEMENT = 'doctorv4/assessment/' //DIagonis
    static DOC_DOCTOR_NOTES_SYMPTOMNS_FREQ = 'doctorv4/frequent/symptoms/'
    static DOC_DOCTOR_NOTES_FAV_PRESCRIPTION = 'doctorv4/favorite/prescription/'
    static DOC_DOCTOR_NOTES_PRESCRIPTION_TEMPLATE = 'doctorv4/prescription/doctor/template/'
    static DOC_DOCTOR_NOTES_PREVIOUS_PRESCRIPTION_APPOINTMENT = 'doctorv4/patient/prescription/appointment/' //
    static DOC_DOCTOR_NOTES_VITALS = 'doctorv4/patient/vitals/'
    static DOC_DOCTOR_NOTES_SURGERY_DETAILS = 'doctorv4/surgery/detail/' //?patient_id=1271070&appointment_id=1066846&clinic_id=10
    static DOC_DOCTOR_NOTES_PATIENT_CATEGORY_WISE = 'doctorv4/wise/category/'
    static DOC_DOCTOR_NOTES_PATIENT_CATEGORY = 'doctorv4/patient/category/'
    static DOC_DOCTOR_NOTES_ALLERGY_FEQ = 'doctorv4/frequent/allergy/'
    static DOC_DOCTOR_NOTES_SYMPTOM_DELETE = 'doctorv4/symptoms/delete/'
    static DOC_DOCTOR_NOTES_TEST_NAME_GET = 'lab/test/config/'
    static DOC_DOCTOR_NOTES_TEST_GROUP_GET = 'lab/test/labset/'
    static DOC_DOCTOR_NOTES_SPECIAL_TEST_SEARCH = 'doctorv4/tests/special/search/'
    static DOC_DOCTOR_NOTES_TEST_POST = 'doctorv4/create/tests/'
    static DOC_DOCTOR_NOTES_TEST_PRINT = 'lab/test/print/'
    static DOC_DOCTOR_NOTES_TEST_DELETE = 'doctorv4/tests/delete/'
    static DOC_DOCTOR_NOTES_TEST_TRANSMIT = 'doctorv4/lab/transmit/test/'
    static DOC_DOCTOR_NOTES_DIAGONIS_ICD_GET = 'doctorv4/frequent/assessment/'
    static DOC_DOCTOR_NOTES_GENERAL_ADVICE = 'doctorv4/advice/template/'
    static DOC_DOCTOR_NOTES_PLAN_FREQ = 'doctorv4/frequent/procedure/'
    static DOC_DOCTOR_NOTES_PLAN_POST = 'doctorv4/create/plan/'
    static DOC_DOCTOR_NOTES_PLAN_DELETE = 'doctorv4/plans/delete/'
    static DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH = 'doctorv4/surgery/search/'
    static DOC_DOCTOR_NOTES_LOCK = 'doctorv4/appointment/'
    static DOC_DOCTOR_NOTES_PLAN_DELETE = 'doctorv4/plans/delete/'
    static DOC_APPOINTMENT_REQUEST = 'doctorv4/appointment/request/'
    static DOC_APPOINTMENT_STATUS = 'doctorv4/appointment/status/'
    static DOC_REGISTRY_SEARCH = 'doctorv4/registry/search/'
    static DOC_REGISTRY_ICD_SEARCH = 'doctorv4/icd/search/'
    static DOC_REGISTRY_GET = 'doctorv4/registry/'
    static DOC_PROVISIONAL_DIAGNOSIS_SUGG_GET = 'doctorv4/provisional-suggestion/'
    static DOC_HISTORY_REPORT_PRINT = 'doctorv4/patient/history/print/'
    static DOC_IMMUNIZATION_PRINT = 'doctorv4/paediatric/immunization/'
    static DOC_DOCTOR_NOTES_PRINT = 'doctorv4/print/visit-report/'
    static DOC_DOCTOR_NOTES_PRINT_OPT = 'doctor/opt/visit/report/'
    static DOC_DOCTOR_NOTES_PRESCRIPTION_FEQ = 'doctorv4/frequent/prescription/'
    static DOC_DOCTOR_NOTES_DRUG_SEARCH = 'pharmacy/drugs/auto-complete/'
    static DOC_DOCTOR_NOTES_GENERIC_NAME_GET = 'fo/drugandgeneric-name/search/'
    static DOC_DOCTOR_NOTES_PRESCRIPTION_PRINT = 'doctorv4/print/prescription/'
    static DOC_DOCTOR_NOTES_PRESCRIPTION_FAV = 'doctorv4/favorite/prescription/'
    static DOC_DOCTOR_NOTES_PRESCRIPTION_TRANSMIT = 'doctorv4/prescription/transmit/'
    static DOC_SCHEDULE_GET = "doctorv4/schedule/time"
    static DOC_TRANSMIT_POST = "doctorv4/opt/transmit/"
    static DOC_NUTRITION_CHART_PRINT = 'doctorv4/meal/plan/'
    static DOC_DOCTOR_NOTES_EXAM_GROUP_GET = 'doctorv4/examination/group/'
    static DOC_DOCTOR_NOTES_DEFAULT_EXAM_SYMPTOM = 'doctorv4/default/examination/'
    static DOC_DOCTOR_NOTES_ADD_NEW_EXAM_SYMPTOM = 'doctorv4/new/examination/'
    static DOC_DOCTOR_NOTES_EXAM_TEMPLATE_LIST = 'doctorv4/favorite/examination/'
    static DOC_DOCTOR_NOTES_EXAM_POST = 'doctorv4/create/update/examination/'
    static DOC_DOCTOR_NOTES_EXAM_DELETE = 'doctorv4/delete/examination/'
    static DOC_DOCTOR_NOTES_LAYOUT = 'doctorv4/notes/layout/'
    static DOC_DOCTOR_NOTES_OPTHOMETRY_NOTES = 'doctor/optometrist-notes/'
    static DOC_PREVIOUS_GLASS_POWER = 'doctor/opt/pgp/'
    static DOC_SUBJECTIVEREFRACTION = 'doctor/opt/subjectiverefraction/'
    static DOC_RETINOSCOPICREFRACTION = 'doctor/opt/additional/subjectiverefraction/'
    static DOC_DOCTOR_NOTES_COMPLAINTS_GET = 'doctor/opt/list/complaints/'
    static DOC_COMPLAINTS_SUGGESTION_GET = 'doctor/opt/complaint/suggestions/'
    static DOC_DOCTOR_NOTES_COMPLAINTS_POST = 'doctor/opt/complaints/'
    static DOC_DOCTOR_NOTES_COMPLAINTS_DELETE = 'doctor/opt/delete/complaint/'
    static DOC_FREQUENT_EYE_TEST_GET = 'imglab/test/testconfig/'
    static DOC_SPECIAL_EYE_TEST_GET = 'doctor/opt/investigation/new/'
    static DOC_DOCTOR_NOTES_POSTERIOR_SEGMENT = "doctor/opt/posterior/segment/"
    static DOC_INTRAOCULARPRESSURE = "doctor/opt/iop/"
    static DOC_TREATMENT_ADVICE = "doctor/opt/treatmentadvice/"
    static DOC_TREAMENT_ADVICE_TEMPLATE = "doctor/opt/treatmentadvicetemplate/"
    static DOC_TREAMENT_ADVICE_DELETE = "doctor/opt/delete/treatment/advice/"
    static DOC_DOCTOR_NOTES_GONIOSCOPY = "doctor/opt/gonioscopy/list/"
    static DOC_AUTO_REFRACTOMETRY = "doctor/opt/autorefractometry/"
    static DOC_KERATOMETRY = "doctor/opt/keratomentry/"
    static DOC_KERATOMETRY_SUGGESTION = "doctor/keratometry/suggestion/"
    static DOC_OCULAR_RESPONSER = "doctor/opt/ocular-response/"
    static DOC_OTHER_INVESTIGATION = "doctor/opt/other-investigation/"
    static DOC_OTHER_INVESTIGATION_SUGGESTION = "doctor/opt/other-investigation/suggestion/"
    static DOC_PREVIOUS_INVESTIGATION = "doctor/opt/previous/other-investigation/"
    static DOC_CALL_PATIENT = "doctorv4/call-patient/"
    static DOC_WENT_FOR_EMERGENCY = "doctorv4/emergency/update/"
    static DOC_OPTOMETRY_OOO_STUATUS = "fo/optometrist/available-status/"
    static DOC_OCCUPATION_GET = "doctor/opt/subref/occupation-list/"
    static DOC_OPT_TAT_GET = "doctorv4/tat-report/"
    static DOC_ENT_CLINICAL_EXAM_GET = "doctorv4/ent/clinicexamination/image/"
    static DOC_ENT_CLINICAL_EXAM_NOTES_GET = "doctorv4/ent/clinic-examination-suggestion/"
    static DOC_DOCTOR_NOTES_CLINICAL_HISTORY = "doctorv4/clinical-history/"
    static DOC_SCHIRMER_API = "doctor/opt/schirmer/"
    static DOC_FINAL_DIAGNOSIS_GET = "doctorv4/additional-notes/"
    static DOC_FINAL_DIAGNOSIS_SUGGESTION = "doctorv4/additional-notes/suggestions/"
    static DOC_PAST_HISTORY_SUGGESTION = "doctorv4/past-history/suggestions/"
    static DOC_PAST_HISTORY_GET = "doctorv4/past-history/"
    static DOC_FINAL_DIAGNOSIS_ICD_GET = 'doctorv4/frequent/final-icd/'
    static DOC_REVIEW_COMMENTS_SUGG_GET = "doctorv4/review-plan-suggestion/"
    static DOC_NEW_LAYOUT_GET = "doctorv4/new-layout/notes/"
    static DOC_NEW_LAYOUT_SUGG_GET = "doctorv4/new-layout/notes/suggestions/"
    static DOC_OBSTETRIC_DATA_GET = "doctorv4/obstetric/data/"

    static DOC_FOOT_EXAMINATION_GET = "doctorv4/foot/examination/"
    static DOC_GAIT_GET = "doctorv4/gait/"
    static DOC_DEFORMITIES_GET = "doctorv4/deformities/"
    static DOC_DEFORMITIES_ADDITIONAL_GET = "doctorv4/deformities-addtional/"
    static DOC_FOOT_EXAMINATION_PRINT = "doctorv4/foot-examination/print/"

    static DOC_LAB_HISTORY_TEST_REPORT_DB = "doctorv4/lab/test-history/"
    static DOC_DOCTOR_NOTES_RADSRV_TRANSMIT = 'doctorv4/radiology/transmit/test/'
    static DOC_MEDICAL_CERTFICATE_GET = 'doctor/opt/medicalform/notes/'
    static DOC_FITNESS_CERTFICATE_GET = 'doctor/opt/fitnessform/notes/'
    static DOC_DEATH_CERTFICATE_GET = 'doctor/opt/deathcertificate/notes/'
    static DOC_DEATH_CERTFICATE_DETAILS_GET = 'doctor/opt/deathcertificate/upload/'
    static DOC_LAB_RAD_TRANSMIT = 'doctorv4/lab/rad/transmit/'
    static DOC_DB_TECHNICIAN_GET = "doctorv4/diabetic/technician-suggestions/"
    static DOC_PATIENT_PRIMARY_PAYMENT_GET = 'doctorv4/patient/primary-payment-type/'
    static DOC_DIABETIC_BLOOD_GLUCOSE_SUGG_GET= 'doctorv4/diabetic/blood-glugose-meter/'
    static DOC_DIABETIC_TYPE_SUGG_GET= 'doctorv4/diabetic/diabetic-type/'
    static DOC_PREVIOUS_DIAGNOSIS_GET = 'doctorv4/assessment/history/'
    static DOC_PREVIOUS_FINAL_DIAGNOSIS_GET = 'doctorv4/additional-notes/history/'
 
    // IP DOCTOR MODULE API STARTS
    static IP_DOC_WRITE_NOTES = "ip/doctor/notes/"
    static IP_DOC_IPOP_CHART = "ip/input/output/chart/"
    static IP_DOC_NUTRITION_CHART_TEMPLATE = "ip/nutrition/chart/template/"
    static IP_DOC_NUTRITION_CHART = "ip/nutrition/chart/"
    static IP_DOCTOR_NOTES_PRINT = "doctorv4/print/doctornotes-report/"
    static IP_MAPPED_DOCTORS = "ip/mapped/doctors/"
    static IP_DRUG_CHART = "ip/drug/chart/"
    static IP_DRUG_CHART_HISTORY = "ip/drug/chart/history/"
    static DOC_DOCTOR_NOTES_RADIOLOGY_POST = 'doctorv4/radiology/test/create/'
    static IP_DOC_GLUCOSE_DRUG_GET = 'ip/glucose-drug/search/'
    static IP_DOC_GLUCOSE_GET = 'ip/glucose-log/'
    static IP_DRUG_CHART_TEMPLATE = 'ip/drug/chart/template/'

    // IP DOCTOR MODULE API ENDS

    // LAB IP LIST
    static IP_LIST_LABHOME = 'pharmacy/ipadmission/list/'
    static IP_LIST_ALL_STATUS = 'fo/ipadmission/list/'
    static PHARMA_PATIENT_ADMISSION_HISTORY = 'pharmacy/patient/appointment/history/'
    static DOC_OPTHALMOLOGY_FREQUENT_DRUG = "doctor/opt/frequent/drug/"
    static DOC_SURGERY_FREQUENT_DRUG = "doctor/opt/frequent/surgery/"
    static DOC_OCULAR_MEDICATION_GET = "doctor/opt/history/ocular/medication/"
    static DOC_OCULAR_SURGERY_GET = "doctor/opt/surgery/"
    static DOC_OCULAR_MEDICATION_DELETE = "doctor/opt/history/ocular/medication/delete/"
    static DOC_OCULAR_SURGERY_DELETE = "doctor/opt/delete/surgery/"

    static DOC_OPT_FREQUENT_ILLNESS = "doctor/opt/frequent/illness/";
    static DOC_OPT_ILLNESS = "doctor/opt/illness/";
    static DOC_OPT_LIST_ILLNESS = "doctor/opt/list/illness/";
    static DOC_OPT_DELETE_ILLNESS = "doctor/opt/delete/illness/";
    static DOC_OPT_DRUG_ALLERGY = "doctor/opt/drug/allergy/";
    static DOC_OPT_FREQUENT_DRUGALLERGY = "doctor/opt/frequent/drugallergy/";
    static DOC_OPT_DELETE_DRUGALLERGY = "doctor/opt/delete/drugallergy/";

    static DOC_OPT_VISIONASSESSMENT = "doctor/opt/visionassessment/";
    static DOC_OPT_REVIEW_PALN = "doctor/opt/reviewplan/";
    static DOC_REVIEW_PLAN_COMMENTS_TEMPLATE = "doctor/opt/reviewplan/comment/template/";
    static FO_CREDIT_BILLS_GET = 'fo/pending/bills/'

    static DOC_OPT_INVESTIGATION = "imglab/test/order/";
    static DOC_OPT_INVESTIGATION_PRINT = "lab/test/print/";

    static DOC_OPT_GLASS_PRESCRIPTION = "doctor/opt/gp/";

    static DOC_DOCTOR_VIST_REPORT_PRINT = 'doctorv4/print/visit-report/'
    static DOC_OVERALL_REVIEW_NOTES = "doctor/patient-notes/"
    static DOC_TRANSFER_REQUEST = "doctorv4/appointment/transfer-request/"
    static DOC_NOTES_AUTO_LOCK = "doctorv4/appointment/auto-lock/"
    static DOC_UNLOCK_DOCTOR_NOTES = "doctorv4/unlocked/notes/"
    static DOC_GP_PRINT = 'doctor/opt/gp/print/'
    static DOC_OPT_CONFIG = 'doctorv4/configurations/'
    static DOC_OPT_FUNDUS_IMG = 'doctor/opt/fundusimage/upload/'
    static OPTHALMOLOGY_ANTERIOR_SEGMENT_IMAGE = 'doctor/opt/anterior/segment/image/'
    static DOC_OPT_REFERRAL_GET = 'doctor/opt/referral/referral_notes_items/'
    static DOC_OPT_REFERRAL_POST = 'doctor/opt/referral/referral_doctor_notes/'
    static DOC_REFERRAL_DOCTOR_OPT = 'doctor/opt/referral/doctor/'
    static DOC_ANTERIOR_SEGMENT_API = 'doctor/opt/anterior/segment/'
    static DOC_FUNDUS_API = 'doctor/opt/fundus/'
    static DOC_MEDICATION_DLT = 'doctor/patient/prescription/'
    static DOC_FOLLOWUP_GET = 'doctor/opt/reviewplan/followup/'
    static DOC_FOLLOWUP_DLT = 'doctor/opt/delete/reviewplan/'
    static DOC_COLLABRATIVE_LOG = 'doctorv4/collaborative/history/'
    static DOC_MEDIC_TEMPLATE_GET_POST = 'doctor/opt/prescription/template/'
    static DOC_ANTERIOR_PREVIOUS_DIAGRAM = 'doctor/anterior/pre-cpy'
    static DOC_FUNDUS_PREVIOUS_DIAGRAM = 'doctor/fundus/pre-cpy/'
    static DOC_RECALL_NOTES_POST = 'doctorv4/patient/recall/notes/'

    static DOC_DISCHARGE_SUMMARY_GET = 'doctorv4/patient/discharge_summary/'

    //Medication
    static DOC_OPT_FREQUENT_MEDICATION = 'doctor/opt/frequent/medication/'
    static DOC_OPT_MEDICATION_DETAILS = 'doctor/opt/drug/details/search/'
    static DOC_OPT_TAPPER_DETAILS_GET_POST = 'doctor/opt/prescription/'
    static DOC_OPT_MEDICATION_FREQUENCY = 'doctor/opt/frequency/template/'
    static DOC_OPT_MEDICATION_HISTORY = 'doctor/medication/history/'
    static DOC_OPT_EXTERNAL_DRUG = 'doctorv4/external/drug-data/'

    // LAB IP LIST
    static IP_LIST_LABHOME = 'pharmacy/ipadmission/list/'

    static IP_OVERALL_DISCOUNT = 'ip/overall/discount/'
    static LAB_PATIENT_TEST_HISTORY = 'lab/patient/test/history/'
    static LAB_SALES_HSN_WISE = 'pharmacy/hsn/wise/report/'
    static PHARMA_VENDOR_BILL = 'pharmacy/vendor-purchase/report'
    static PHARMA_HSN_REPORT = 'pharmacy/reports/purchase/hsn/'
    static PHARMA_TAX_WISE_SALES = 'pharmacy/tax/wise/report/'
    static PHARMA_PURCHASE_RETURN_HSN_REPORTS = 'pharmacy/reports/purchase/return/hsn/'
    static PHARMA_PURCHASE_RETURN_VENDOR_REPORTS = 'pharmacy/vendor/po-return/report/'
    static PHARMA_PRESCRIPTION_REG = 'pharmacy/prescription/register/'

    static GET_BILL_MODIFY_HISTORY = "ip/billsummary/history/log/"
    static PHARMA_PO_REQUEST_PRINT = 'pharmacy/purchase-order/'
    static PHARMA_NEW_VENDOR_PAYMENT = 'pharmacy/vendor/po/'
    static PHARMA_NEW_VENDOR_RECEIPT = 'pharmacy/vendor/receipt/'

    // LAB MASTER
    static GET_LAB_DEPARTMENT_MASTER = 'lab/department/master/'
    static GET_LAB_CONTAINER_MASTER = 'lab/container/master/'
    static GET_LAB_SPECIMEN_MASTER = 'lab/specimen/master/'
    static GET_LAB_METHOD_MASTER = 'lab/methodmaster/'


    // OPT Previous History API
    static DOC_PGP_PREVIOUS_GLASS_POWER = 'doctor/pgp/history/'
    static DOC_SUBJECTIVEREFRACTION_PREVIOUS = 'doctor/opt/previous/subjectiverefraction/'
    static DOC_RETINO_REFRACTION_PREVIOUS = 'doctor/asr/history/'
    static DOC_AUTO_REFRACTO_PREVIOUS = 'doctor/auto-refractometry/history/'
    static DOC_PREVIOUS_POSTERIOR_SEGMENT = 'doctor/posterior/segment/history/'
    static DOC_PREVIOUS_KERATOMETRY = 'doctor/keratomentry/history/'
    static DOC_KERATOMETRY_CURVATURE = 'doctor/opt/keratomentry/curvature/'
    static DOC_PREVIOUS_GONIOSCOPY = 'doctor/gonioscopy/history/'
    static DOC_PREVIOUS_GLASS_PRESCRIPTION = 'doctor/glass-prescription/history/'
    static DOC_PREVIOUS_VISION = 'doctor/vision-assessment/history/'
    static DOC_PREVIOUS_ANTERIOR_SEGMENT = 'doctor/anterior/segment/history/'
    static DOC_SUGGESTION_ANTERIOR_SEGMENT = 'doctorv4/anterior-segment/suggestion/'

    //Optical CRM
    static OPTICAL_CRM_CUSTOMER_DETAIL = 'optical-crm/customer-detail/'
    static OPTICAL_CRM_PATIENT_DETAIL = 'optical-crm/patient-detail/'
    static OPTICAL_CRM_CUSTOMER_ADD = 'customer_add.php/'
    static OPTICAL_CRM_PRESCRIPTION_POST = 'prescription_add.php/'

    static FO_PRINT_ORDER = 'fo/test/order/'
    // Help Desk
    static HELPDESK = 'fo/help_desk/request/'
    static PHARMACY_DUPLICATE_BILL_DC_CHECK = 'v2/pharmacy/bill/duplicate_check/'
    //Peadiatric
    static PD_DEVELOP_ASSESS = 'doctorv4/new/developmentalassessment/'
    static PD_DEVELOP_ASSESS_POST = 'doctorv4/denverscreening/'
    static PD_IMMUNIZATION_GET = 'doctorv4/paediatric/immunization/'
    static PD_IMMUNIZATION_LOCK = 'doctorv4/paediatric/immunization/freeze/'
    static PD_HISTORY_GET = 'doctorv4/paediatric/birthhistory/'
    static PD_MEDICAL_HIS = 'doctorv4/paediatric/medicalnew/problems/'
    static PD_MEDICAL_HIS_DEL = 'doctorv4/paediatric/medical/problems/delete/'
    static PD_GROWTH_CHART = 'doctorv4/paediatric/growth/chart/'

    // Canteen
    static CANTEEN_GET = "canteen/canteen-item/"
    static CANTEEN_OVERALL = "canteen/overall/"
    static CANTEEN_CANCEL = "canteen/cancel/"
    static CANTEEN_CREDITBILL = "canteen/credit/"
    static CANTEEN_RECEIPTBILL = "canteen/receipt/"
    static CANTEEN_DAYENDBILL = "canteen/dayend/"
    static CANTEEN_BILLING = "canteen/billing/"
    //Asset Management
    static ASSET_LIST_GET_POST = 'asset/assetlist/'
    static ASSET_LIST_BAR_CODE = 'asset/assetbarcode/'
    static ASSET_TRANSFER_GET_POST = 'asset/asset-transfer/'
    static ASSET_AUDIT_GET = 'asset/audit/'
    static ASSET_CATEGORY_GET_POST = 'asset/category/'
    static ASSET_SUB_CATEGORY_GET_POST = 'asset/subcategory/'
    static ASSET_BLOCK_LIST_GET_POST = 'asset/block/'
    static ASSET_FLOOR_LIST_GET_POST = 'asset/floor/'
    static ASSET_SPOT_LIST_GET_POST = 'asset/spot/'
    static ASSET_DESIGN_LIST_GET_POST = 'asset/designation/'
    static ASSET_EMPLOYEE_LIST_GET_POST = 'asset/employee/'
    static ASSET_AUDIT_SEARCH_ASSETNO = 'asset/assetno/'
    static PURCHASE_WISE_ENQUIRY = "pharmacy/product/wise/report"
    static ASSET_PRINT_LAYOUT_CONFIG = "asset/print-configuration/"

    static POSITIVE_CENSUS_REPORT = 'lab/census/pos_neg/'

    static INSURANCE_MASTER = 'fo/insurance-list/'

    static LEGER_REPORT_BED_AVAILABLE_GET = 'ip/bed/available/ledger/'
    static PRE_AUTHORIZATION_POST = 'ip/pre-auth/claim/'
    static OP_PRE_AUTHORIZATION_POST = 'ip/op/insurance/pre-auth/claim/'
    static POST_PATIENT_CREDIT_TYPE = 'ip/patient/credit-type/'
    static IP_OCCUPENCY_REPORT_GET = 'ip/occupancy/report/'
    static DAY_END_MODULE_BASED = 'fo/dayend/bill/report/module/'
    static PHARMACY_SUBLOC_STOCKLIST = 'pharmacy/sub_loc/stock/list/view/'
    static LAB_PACKAGE_REPORT = 'lab/package/report/'

    static FO_IP_OP_PATIENT_TAG_CHANGE_NORMAL = 'ip/patient/tag/update/'

    static PHARMA_PO_CREDIT_NOTE_VENDOR_GET = 'pharmacy/po-return/new/'
    static PHARMA_PO_CREDIT_NOTE_POST = 'pharmacy/credit-note/po-return/'
    static PHARMA_CREDIT_NOTE_REPORT = 'pharmacy/credit-note/po-return/'
    static FO_DAY_END_DETAILED_PRINT = 'fo/dayend/bill/print/'

    // Tally Report
    static TALLY_REPORT = 'reports/masonic/list/'

    static SUBLOC_EXPIRY_STOCK = 'sublocation/expiry/'
    static SUBLOC_STOCK_VALUE_DETAIL = 'sublocation/stock/value/'
    static OT_STOCK_VALUE_DETAIL = 'ot/stock/value/'
    static OPT_SUB_REFRACTION_SUGG = 'doctor/subjectiverefraction/suggestion/'
    static OPT_RETINOSCOPIC_ACCEPTANCE = 'doctor/retinoscopicacceptance/'
    static OPT_RETINOSCOPIC_ACCEPTANCE_PREVIOUS = 'doctor/retinoscopicacceptanceprevious/'
    static OPT_RETINOSCOPIC_ACCEPTANCE_SUG = 'doctor/retinoscopicacceptancesuggestion/'

    //branch Module
    static BRANCH_MOD_BRANCHES_GET = 'fo/dashboard/chart/new/'
    static BRANCH_MOD_PHARMACY_SLOWMOVE_GET = 'fo/dash/pharmacy/slow/moment/drug/'
    static BRANCH_MOD_PHARMACY_NEWARRIVAL_GET = 'fo/dash/pharmacy/new/arrival/drug/'
    static BRANCH_MOD_TOTAL_PATIENT_DOC_COUNT = 'fo/dashboard/patient/doctor/count/'
    static BRANCH_MOD_CUSTOM_CONFIG = 'core/org/custom-config/ '

    static CANTEEN_RECEIPT_PRINT = "canteen/receipt/print/"

    static ASSET_NEW_BLOCK_FLOOR_GET = 'asset/spot/area/'
    static ASSER_NEW_CAT_SUB_CAT_GET = 'asset/category/subcategory/'
    static ASSET_COMPLAINT_GET_POST = 'asset/assetcomplaints/'
    static ASSET_STATUS_LOG_POST_GET = 'asset/complaint/status/'
    static ASSET_GATE_PASS_PRINT = 'asset/gatepass/'
    static LAB_DAY_END_REPORT_GET = 'lab/dayend/report/'

    // DOCTOR - OBGYN urls
    static OVULATION_INDUCTION_DATA_GET = 'doctorv4/obgyn/ovulationinduction/'
    static OVULATION_INDUCTION_LIST = 'doctorv4/obgyn/ovulationinduction/list/'
    static OVULATION_INDUCTION_POST = 'doctorv4/obgyn/ovulation/induction/'
    static OVULATION_INDUCTION_TEMPLATE_LIST = 'doctorv4/obgyn/ovulation/induction/template/values/'
    static OVULATION_INDUCTION_DELETE = 'doctorv4/obgyn/ovulation/induction/delete/'
    static OVULATION_INDUCTION_PRINT = 'doctorv4/obgyn/ovulation/induction/print/'
    static ANTENATAL_OBS_DATA_POST = 'doctorv4/obgyn/antenatalchart/'
    static ANTENATAL_SCAN_LIST = 'doctorv4/obgyn/antenatal/scan/list/'
    static ANTENATAL_INVESTIGATION_CHART = 'doctorv4/obgyn/antenatal/investigation/chart/'
    static ANTENATAL_OBSTETRIC_HISTORY = 'doctorv4/obgyn/antenatal/obstetric/history/'
    static ANTENATAL_PHYSICAL_EXAMINATION = 'doctorv4/obgyn/antenatal/physical/examination/'
    static ANTENATAL_SCAN_OBSERVATION = 'doctorv4/obgyn/antenatal/scan/'
    static ANTENATAL_VACCINATION = 'doctorv4/obgyn/antenatal/vaccination/'
    static ANTENATAL_COMPLETE = 'doctorv4/obgyn/antenatal/complete/'
    static ANTENATAL_CHART_PRINT = 'doctorv4/obgyn/antenatal/print/'

    static MENSTRUAL_HISTORY = 'doctorv4/obgyn/menstrual/history/'
    static OBSTETRICAL_HISTORY_GET = 'doctorv4/obgyn/obstetricalhistory/'
    static OBSTETRICAL_HISTORY_POST_AND_UPDATE = 'doctorv4/obgyn/obstetricalhistory/create/update/'
    static OBSTETRICAL_HISTORY_DELETE = 'doctorv4/obgyn/obstetricalhistory/delete/'
    static BIRTH_CONTROL_GET = 'doctorv4/obgyn/birthcontrol/'
    static BIRTH_CONTROL_POST_AND_UPDATE = 'doctorv4/obgyn/birthcontrol/create/update/'
    static GYNAECOLOGICAL_HISTORY = 'doctorv4/obgyn/gynaecology/history/'
    static PAP_HISTORY = 'doctorv4/obgyn/pap/mammogram/history/'
    static OBGYN_SURGERY_GET_POST = 'doctorv4/obgyn/obstetrical/surgeries/history/'

    static PHARMA_PRESC_LIST_HISTORY_GET = 'pharmacy/prescriptions/list/'

    // RADIOLOGY API STARTS ===> 

    static RAD_SERVICE_CONFIG = 'radiology/service/config/'
    static RAD_TEST_TEMPLATE_CONFIG = 'radiology/service/template/config/'
    static RAD_TEST_TEMPLATE_CONFIG_NEW = 'radiology/service/template/config/new/'
    static INVESTIGATION_TEST_TEMPLATE_CONFIG_NEW = 'investigation/service/template/config/new/'
    static RAD_BILL_POST = 'radiology/create/bill/'
    static RAD_SAVED_BILL_GET = 'radiology/saved/bill/view/'
    static RAD_SAVED_BILL_ITEM_GET = 'radiology/bill/'
    static RAD_BILL_RECEIVED_POST = 'radiology/bill/complete/'
    static RAD_OVER_ALL_BILL_TRANS_GET = 'radiology/overall-bill/'
    static RAD_CANCEL_BILL_TRANS_GET = 'radiology/cancel-bill/'
    static RAD_SAVED_BILL_TRANS_GET = 'radiology/saved-bill/'
    static RAD_RECEIPT_BILL_TRANS_GET = 'radiology/receipt-bill/'
    static RAD_PATIENT_BILLS_GET = 'radiology/bill/view/'
    static RAD_PATIENT_APPOINTMENT_LIST = 'radiology/home/view/'
    static INVESTIGATION_PATIENT_APPOINTMENT_LIST = 'investigation/home/view/new'
    static RAD_DAY_END_BILL_TRANS_GET = 'radiology/dayend-bill/'
    static RAD_APPOINTMENT_GET = 'lab/appointments/list/'
    static RAD_CENCUS_REPORT = 'radiology/census/report/'
    static RAD_PATIENT_REPORT = 'radiology/patient/service/report/'
    static RAD_PATIENT_SAVED_BILL_LIST = 'radiology/saved/bill/list/'
    static RAD_RESULT_GET = 'radiology/billing/result/'
    static INVESTIGATION_RESULT_GET = 'investigation/billing/result/'
    static RAD_CANCEL_BILL = 'radiology/bill/cancel/'
    static RAD_CREDIT_BILL_TRANS_GET = 'radiology/credit-bill/'
    static RAD_RECEIPT_BILL_GET = 'radiology/receipt/bill/list/'
    static RAD_NOTES = 'radiology/patient/notes/'
    static INVESTIGATION_NOTES = 'investigation/patient/notes/'
    static RAD_RESULT_PRINT = 'radiology/bill/service/print/'
    static RAD_PATIENT_TRANSMIT_GET = "radiology/transmitted/test-list/"
    static RAD_TAT_REPORT = 'radiology/rad/tat/report/'
    static RAD_BARCODE_PRINT = 'radiology/bill/barcode/'
    static RAD_RESULT_GET_NEW = 'radiology/billing/result/new/'
    static INVESTIGATION_RESULT_GET_NEW = 'investigation/billing/result/new/'
    static RAD_RESULT_PRINT_CONFIGURATION = 'radiology/print/configuration/'
    static INVESTIGATION_RESULT_PRINT_CONFIGURATION = 'investigation/print-configuration/'


    // Account Report 
    static TALLY_ADVANCE_RPT_GET = 'accounts/advance/report/'
    static ACC_REF_CANCEL = 'accounts/cancel/refund/'
    static ACC_BILL_WISE_RPT_GET = 'accounts/billview/task/'
    // Registration Form API's
    static FO_QR_ENTRY_LIST = 'fo/qr-entry/list/'
    static REGISTRATION_FORM_POST = 'fo/qr-appointment/registration/'
    static SMS_SEND = 'core/ebill/sms/'

    static LAB_DOCTOR_SHARE = 'lab/doctor/config/'
    static LAB_GRP_TST_PACK_GET = 'lab/test/grp/package/'

    static LAB_SHARE_REPORT_GET = 'lab/share/report/'
    static OP_SERVICE_CODE_LIST = 'fo/service/code/'
    static IP_SERVICE_CODE_LIST = 'ip/service/code/'
    static RAD_SERVICE_CODE_LIST = 'radiology/service_code_list/'
    static OT_TAT_REPORT_GET = 'ot/report/tat/'

    static FO_BADGE_COUNT_GET = 'fo/appointment/request/count/'

    static PHARMACY_STOCK_CONFIG = 'core/pharmacy/stock/configuration/'

    // branch to branch 
    static PHA_BRANCH_TOLOC = 'v2/pharmacy/org/pharmacy/'
    static PHA_BRANCH_DRUGSEARCHLIST = 'v2/pharmacy/global/drug/list/'
    static PHA_BRANCH_DRUGSEARCH = 'v2/pharmacy/global/drug/search/'
    static PHA_BRANCH_REQ_POST = 'v2/pharmacy/stock/transfer/'
    static PHA_BRANCH_LINE_OF_ITEM = 'v2/pharmacy/inbound/line/'
    static PHA_BRANCH_STATUS_CHANGE = 'v2/pharmacy/request/status/'
    static PHA_BRANCH_TRANSIT = 'v2/pharmacy/transit/details/'
    static PHA_BRANCH_STOCK_REPORT = 'v2/pharmacy/stock/transfer/list/'
    static PHA_BRANCH_STOCK_LIST = 'v2/pharmacy/stock/list/'
    static PHA_BRANCH_WANTED_LIST = 'v2/pharmacy/b2b/wanted/list/'
    static PHA_BRANCH_DRUGWISE_STOCKTRANSFER_REPORT = 'v2/pharmacy/b2b/drugwise/list/'
    //QMS
    static QMS_CONFIG = 'fo/qms/config/'
    static FO_DOC_QUEUE_GET = 'fo/drqueue/list/'

    static DOC_SESSION_CONFIG = 'doctorv4/session/config/'
    static DOC_ROOMNO_CONFIG = 'doctorv4/room/detail/'
    static DOC_DETAILS_PROFILE = 'doctorv4/profile/details/'

    static DOC_SCHEDULE_DATA_GET = 'doctorv4/schedule/list-view/'
    static DOC_SCHEDULE_OUTOFOFFICE = 'doctorv4/mark/out-of-office/'
    static DOC_RUNNING_LATE_POST = 'doctorv4/running/late/'
    static DOC_SESSION_LIST = 'doctorv4/session/list/'
    static FO_NOTIFICATION_GET = 'fo/home/notifications/'

    static DOC_EMERGENCY_WEBSOCKET = 'emergency-update/'
    static DOC_RUNNINGLATE_WEBSOCKET = 'running-late/'
    static DOC_OUTOFOFFICE_WEBSOCKET = 'doctor/out-of-office/'
    static DOC_PATIENTCALL_WEBSOCKET = 'patient-call/'
    static FO_CALLPATIENT_WEBSOCKET = 'fo/call-update/'
    static TOKENSCREEN_WEBSOCKET = 'token-screen/'

    static FO_INTERNAL_CMT = "fo/appointment/comments"
    static LAB_IP_REQUEST_TRANSMIT = 'ip/lab/transmit/'
    static DOC_NOTES_IOL_MASTER = 'doctor/opt/iol_master/'

    static LAB_TEST_CODE_LIST = 'lab/test_code_list/'
    static DOC_PRESCIPTION_USAGE_LIST = 'doctorv4/prescriptions/usage_list/'
    static PHARMACY_USER_DAYEND_SALES = 'pharmacy/day/end/denomination/'
    static DOC_PRESCRIPTION_DOSAGEFORM_LIST = "doctorv4/prescriptions/dosage_unit_list/"

    //New Master Configuration
    static MODULE_LIST = 'billing/service/summary/'
    static FO_LAB_SEARCH = 'billing/lab/service/'
    static NEW_DEPARTMENT_MASTER = 'billing/service/config/'
    static CONFIGURATION_SERVICE_SEARCH = 'billing/service/config/search/'
    static NEW_TEMPLATE_CONFIGURATION = 'billing/template/config/'
    static NEW_PACKAGE_CONFIGURATION = 'billing/package/config/'
    static SURGERY_MAPPING_CONFIGURATION = 'billing/surgery_package/'
    static HEAD_CONSULTATION_LIST = 'billing/consultation/service/'
    static NEW_INSURANCE_PACKAGE_CONFIG = "billing/insurance/package/config/"
    static NEW_INSURANCE_PACKAGE_MASTER = "billing/insurance/package/config/master/"

    //New Common Billing
    static BILLING_CREATE_ORDER = 'billing/op/create/order/'
    static BILLING_CREATE_ORDER_IP = 'billing/ip/create/order/'
    static BILLING_CREATE_ORDER_LAB = 'billing/lab/create/order/'
    static BILLING_ORDER_LIST = 'billing/op/appointment/order/view/'
    static BILLING_ORDER_LIST_IP = 'billing/ip/admission/order/view/'
    static BILLING_OP_PENDING_ORDER_LIST = 'billing/op/pending/order/'
    static BILLING_IP_PENDING_ORDER_LIST = 'billing/ip/pending/order/'
    static BILLING_OP_CORPORATE_LIST = 'billing/search/corporate/'

    //celery concept
    static CELERY_DEMO_START = "reports/get_task/"

    //aws url
    static AWS_URL_GET = "fo/aws-s3/url/"
    static LAB_ESIGN_UPLOAD = "fo/aws-s3/url/"

    static INDENT_REQ_COUNT = 'pharmacy/indent/batch/'

    static LOGIN_RESET_PASS = 'auth/password/change/'

    static FO_DAY_WISE_CATEGORY_SALES_REPORT = 'fo/daywise/category-sales/'
    static FO_DAY_WISE_DEPARTMENT_LIST = 'fo/lab/department-list/'

    static FO_IP_MEDICATION_RTN_LIST = 'ip/medications/return/'
    static PHARMA_PURCHASE_RTN_PRINT = 'pharmacy/po/return/'
    static PHARMA_PURCHASE_REJECTION_PRINT = 'pharmacy/purchase_rejection/lineitem_print/'

    static FO_TRANS_LIST_GET = 'fo/appointment/transfer/'
    static ASS_GET_DRUG_MASTER = 'ip/ipdrug/config/'
    static ASS_GET_DRUG_PACKAGE = 'ip/drug/package/'
    static ASS_GET_ASSORTED_PACKAGE = 'ip/assorted/package/'

    static COLLAB_VISIT_DATE_GET = 'doctorv4/visit_date/'

    static FO_MULTI_BILLING_POST = 'fo/overall/bill-create/'
    static FO_MULTI_BILLING_PATIENT_SEARCH = 'fo/overall/patient-search/'

    static OT_SALES_HSN_WISE = 'ot/sales-hsn-wise/report/'
    static OT_SALES_TAX_WISE = 'ot/sales-tax-wise/report/'

    //ABDM
    static ABHA_AADHAAR_OTP_REQUEST = 'abdm/aadhaar/otp/request/'
    static ABHA_AADHAAR_OTP_VERIFY = 'abdm/aadhaar/otp/verify/'
    static ABHA_PATIENT_HIP_LINK = 'abdm/hip-link/'
    static ABHA_PATIENT_HIP_LINK_CHECK = 'abdm/hip-link/check/'
    static ABHA_PATIENT_HIP_LINK_LIST = 'abdm/hip-link/history/'
    static ABHA_PATIENT_REVISIT_SEARCH = 'abdm/hip-link/revisit/'
    static ABHA_PATIENT_HIP_CARE_CONTEXT_LIST = 'abdm/patient/care-context/'
    static ABHA_PATIENT_HIP_FHIR_LIST = 'abdm/patient/care-context/fhir/'
    static ABHA_PATIENT_HIP_CONTEXT_NOTIFY_LIST = 'abdm/patient/care-context/notification/'
    static ABHA_PATIENT_ABHA_REGISTER = 'abdm/patient/link/'
    static ABHA_PATIENT_HIP_CARE_CONSENT_LIST = 'abdm/patient/care-consent/'
    static ABHA_PRESCRIPTION_BUNDLE = 'abdm/patient/care-consent/fhir/bundle/' 
    static ABHA_BUNDLE_CHECK = 'abdm/patient/share/api/v3/fhir-bundle' 
    static HAVE_ABHA_OTP_REQUEST = 'abdm/patient/have-abha/request/'
    static HAVE_ABHA_OTP_VERIFY = 'abdm/patient/have-abha/verify/'
    static ABHA_CONSENT_INIT = 'abdm/patient/care-consent/hiu/request/'
    static ABHA_PATIENT_FIND = 'abdm/patient/find/'
    static ABHA_PATIENT_ABHA_CARD_DOWNLOAD = 'abdm/download-abha/'
    static ABHA_PATIENT_ABHA_SUGGESTION = 'abdm/abha-address/suggesstions/'
    static ABHA_CUSTOM_ADDRESS_POST = 'abdm/abha-address/create/'
    static ABHA_QR_ENTRY_LIST = 'abdm/patient/qr/requests/'
    static HAVE_ABHA_MOBILE_CHECK = 'abdm/patient/have-abha/search/'
    static ABHA_REGISTER_LIST = 'abdm/patient/recent-registration/'
    static ABHA_CONSENT_BUNDLE_VIEW = 'abdm/patient/care-consent/fhir/bundle/'
    static SEARCH_OTP_AUTH_MODE = 'abdm/patient/have-abha/abha-address/auth-modes/'

    
    // NEW DOC NOTES API
    static NEW_DOC_NOTES_COMPLAINTS = 'doctorv4/opt/complaints/'
    static NEW_DOC_NOTES_COMPLAINTS_SUGG = 'doctorv4/opt/complaints-suggestion/'
    static NEW_DOC_NOTES_PAT_CATEGORY = 'doctorv4/opt/patient-category/'
    static NEW_DOC_NOTES_PAT_CATEGORY_SUGG = 'doctorv4/opt/patient-category/suggestion/'
    static NEW_DOC_NOTES_VITALS = 'doctorv4/opt/patient-vitals/'
    static NEW_DOC_NOTES_OCULAR_HISTORY = 'doctorv4/opt/ocular-history/'
    static NEW_DOC_NOTES_OCULAR_HISTORY_SUR_SUGG = 'doctorv4/opt/ocular-surgery/suggestion/'
    static NEW_DOC_NOTES_OCULAR_HISTORY_CONTACT_LENS_SUGG = 'doctorv4/opt/ocular-contactlense/suggestion/'
    static NEW_DOC_NOTES_OCULAR_HISTORY_OTHERS_SUGG = 'doctorv4/opt/ocular-other/suggestion/'
    static NEW_DOC_NOTES_OCULAR_HISTORY_MED_SUGG = 'doctorv4/opt/ocular-medication/suggestion/'
    static NEW_DOC_NOTES_APPOINTMENT_STATUS = 'doctorv4/appointment/status/update/'
    static NEW_DOC_NOTES_LOCK = 'doctorv4/appointment/'
    static NEW_DOC_NOTES_APPOINTMENT_DETAILS = 'fo/appointment/details/'
    static NEW_DOC_NOTES_SYSTEMIC_ILLNESS = 'doctorv4/opt/systemic-illness/'
    static NEW_DOC_NOTES_ILLNESS_SUGG = 'doctorv4/opt/systemic-illness/suggestion/'
    static NEW_DOC_NOTES_ALLERGY_SUGG = 'doctorv4/opt/systemic-allergy/suggestion/'
    static NEW_DOC_NOTES_PREV_GLASS_POWER = 'doctorv4/opt/create-pgp/'
    static NEW_DOC_NOTES_PREV_GLASS_POWER_COPY = 'doctorv4/opt/previous-pgp/'
    static NEW_DOC_NOTES_TRANSFER = 'doctorv4/appointment/transfer-request/'
    static NEW_DOC_NOTES_APPOINTMENT_CREATE = 'doctorv4/appointment/create/'
    static NEW_DOC_NOTES_VISSION_ASSESSMENT = 'doctorv4/opt/vision-assessment/'
    static NEW_DOC_NOTES_VISSION_ASSESSMENT_COPY = 'doctorv4/opt/previous-va/'
    static NEW_DOC_NOTES_OCCUPATION_LIST = 'doctorv4/opt/occupation-list/'
    static NEW_DOC_NOTES_RETINO_REFRACTION = 'doctorv4/opt/retinoscopic-refraction/'
    static NEW_DOC_NOTES_RETINO_REFRACTION_COPY = 'doctorv4/opt/previous-retinoscopic/'
    static NEW_DOC_NOTES_AUTO_REFRACTOMENTRY = 'doctorv4/opt/auto-refractometry/'
    static NEW_DOC_NOTES_AUTO_REFRACTOMENTRY_COPY = 'doctorv4/opt/previous-autorefraction/'
    static NEW_DOC_NOTES_SUB_REFRACTION = 'doctorv4/opt/subjective-refraction/'
    static NEW_DOC_NOTES_SUB_REFRACTION_COPY = 'doctorv4/opt/previous-subref/'
    static NEW_DOC_NOTES_INTRAOCULAR_PRESSURE = 'doctorv4/opt/intraocular-pressure/'
    static NEW_DOC_NOTES_OCULAR_RESP_ANALYSER = 'doctorv4/opt/ocular-response/'
    static NEW_DOC_NOTES_OCULAR_RESP_ANALYSER_COPY = 'doctorv4/opt/previous/ocular-response/'
    static NEW_DOC_NOTES_ANTERIOR_SEGMENT = 'doctorv4/opt/anterior-segment/'
    static NEW_DOC_NOTES_ANTERIOR_SEGMENT_SUGG = 'doctorv4/opt/anterior-segment-suggestion/'
    static NEW_DOC_NOTES_ANTERIOR_SEGMENT_COPY = 'doctorv4/opt/previous-anterior-segment/'
    static NEW_DOC_NOTES_ANTERIOR_DIAGRAM = 'doctorv4/opt/anterior-segment-image/'
    static NEW_DOC_NOTES_ANTERIOR_DIAGRAM_COPY = 'doctorv4/opt/previous-anterior-image/'
    static NEW_DOC_NOTES_POSTERIOR_SEGMENT = 'doctorv4/opt/posterior-segment/'
    static NEW_DOC_NOTES_POSTERIOR_SEGMENT_COPY = 'doctorv4/opt/previous-posterior-segment/'
    static NEW_DOC_NOTES_POSTERIOR_SEGMENT_SUGG = 'doctorv4/opt/posterior-segment-suggestion/'
    static NEW_DOC_NOTES_FUNDUS_DIAGRAM = 'doctorv4/opt/fundus-image/'
    static NEW_DOC_NOTES_FUNDUS_DIAGRAM_COPY = 'doctorv4/opt/previous-fundus-image/'
    static NEW_DOC_NOTES_DIAGNOSIS = 'doctorv4/opt/diagnosis/'
    static NEW_DOC_NOTES_DIAGNOSIS_PROV_SUGG = 'doctorv4/opt/diagnosis-suggestion/'
    static NEW_DOC_NOTES_DIAGNOSIS_SEARCH = 'doctorv4/icd/search/'
    static NEW_DOC_NOTES_OTHER_INVESTIGATION = 'doctorv4/opt/other-investigation/'
    static NEW_DOC_NOTES_OTHER_INVESTIGATION_SUGG = 'doctorv4/opt/other-investigation/suggestion/'
    static NEW_DOC_NOTES_OTHER_INVESTIGATION_COPY = 'doctorv4/opt/previous-other-investigation/'
    static NEW_DOC_NOTES_IOL_MASTER = 'doctorv4/opt/iol-master/'
    static NEW_DOC_NOTES_TREATMENT_PLAN = 'doctorv4/opt/treatment-plan/'
    static NEW_DOC_NOTES_TREATMENT_PLAN_TEMPLATE = 'doctorv4/opt/treatment-plan/template/'
    static NEW_DOC_NOTES_NOTES = 'doctorv4/opt/create-notes/'
    static NEW_DOC_NOTES_OPTOMETRY_NOTES = 'doctorv4/opt/optometrist-notes/'
    static NEW_DOC_NOTES_GONIOSCOPY = 'doctorv4/opt/create-gonioscopy/'
    static NEW_DOC_NOTES_KERATOMENTRY = 'doctorv4/opt/create-keratomentry/'
    static NEW_DOC_NOTES_KERATOMENTRY_COPY = 'doctorv4/opt/previous-keratomentry/'
    static NEW_DOC_NOTES_REVIEW_PLAN = 'doctorv4/opt/review-plan/'
    static NEW_DOC_NOTES_INVESTIGATION_SPECIAL_SEARCH = 'doctorv4/tests/special/search/'
    static NEW_DOC_NOTES_INVESTIGATION_LAB_TEST = 'doctorv4/opt/lab-tests/'
    static NEW_DOC_NOTES_INVESTIGATION = 'doctorv4/opt/create-investigation/'
    // static NEW_DOC_NOTES_COUNSELLOR = 'doctorv4/opt/create-surgery-request/'
    static NEW_DOC_NOTES_COUNSELLOR = 'doctorv4/surgery/detail/'
    static NEW_DOC_NOTES_GLASS_PRESCRIPTION = 'doctorv4/opt/glass-prescription/'
    static NEW_DOC_NOTES_GLASS_PRESCRIPTION_COPY = 'doctorv4/opt/previous/glass-prescription/'
    static NEW_DOC_NOTES_MEDICATION = 'doctorv4/opt/medication/'
    static NEW_DOC_NOTES_DRUG_FREQ = 'doctorv4/opt/drug-medication/'
    static NEW_DOC_NOTES_DRUG_FAV = 'doctorv4/opt/favorite-medication/'
    static NEW_DOC_NOTES_MEDICATION_TRANSMIT = 'doctorv4/opt/transmit-medication/'
    static NEW_DOC_NOTES_PREV_MEDICATION = 'doctorv4/opt/medication-previous/'
    static NEW_DOC_NOTES_MEDICATION_TEMPLATE = 'doctorv4/opt/medication-template/'
    static NEW_DOC_NOTES_VISIT_REPORT_PRINT = 'doctorv4/opt/pdf/visit-report/'
    static NEW_DOC_NOTES_GLASS_PRESCRIPTION_SUGG = 'doctorv4/opt/glass-prescription/suggestion/'
    static NEW_DOC_SURGERY_REPORT = 'fo/surgery/report/'
    static FO_IMA_REGISTRATION = 'fo/ima/'
    static NEW_DOC_NOTES_SMILE = 'doctorv4/opt/smile-refraction/'
    static NEW_DOC_NOTES_PREV_SMILE = 'doctorv4/opt/previous-smile/'
    static NEW_DOC_NOTES_PRESBYOND = 'doctorv4/opt/presbyond-refraction/'
    static NEW_DOC_NOTES_PREV_PRESBYOND = 'doctorv4/opt/previous-presbyond/'
    
    // store module
    static STORE_VENDOR = 'store/vendor/'
    static STORE_DEPARTMENT = 'store/department/'
    static STORE_CATEGORY = 'store/category/'
    static STORE_SUB_CATEGORY = 'store/sub-category/'
    static STORE_PRODUCT_TYPE = 'store/product/type/'
    static STORE_PRODUCT = 'store/product/'
    static STORE_VENDOR_MAPPING = 'store/vendor-category/mapping/'
    static STORE_PURCHASE_REQUEST = 'store/purchase/request/'
    static STORE_PURCHASE_INWARD = 'store/purchase/inward/'
    static STORE_PURCHASE_REJECTION = 'store/purchase/rejection/'
    static STORE_PURCHASE_RETURN = 'store/purchase/return/'
    static STORE_VENDOR_PAYMENT = 'store/vendor/payment/'
    static STORE_VENDOR_PAYMENT_MONTHLY = 'store/vendor/po/payment/'
    static STORE_VENDOR_PAYMENT_RECEIVE = 'store/vendor/payment/receive/'
    static STORE_VENDOR_PAYMENT_RECEIPTS = 'store/vendor/payment/receipts/'
    static STORE_PRODUCT_STOCK_LIST = 'store/product/list/'
    static STORE_PRODUCT_STOCK_CORRECTION = 'store/stock/correction/update/'
    static STORE_BATCH_SEARCH = 'store/product/search/'
    static STORE_CREDIT_NOTE = 'store/credit-note/'
    static STORE_CREDIT_NOTE_VENDOR_SEARCH = 'store/credit-note/vendor/search/'
    static STORE_PRODUCT_UOM = 'store/uom/'
    static STORE_PURCHASE_REPORT = 'store/purchase/report/'
    static STORE_PURCHASE_HSN_REPORT = 'store/purchase/hsn/report/'
    static STORE_PURCHASE_RETURN_HSN_REPORT = 'store/purchase/return/hsn/report/'
    static STORE_PURCHASE_RETURN_REPORT = 'store/purchase/return/report/'
    static STORE_VENDOR_PERFORMANCE_REPORT = 'store/vendor/performance/'
    static STORE_STOCK_VALUE_REPORT = 'store/stock/value/report/'
    static SUB_LOCATION_CREATION_MASTER = 'fo/sub_location/masters/'
    static STORE_STOCK_TRANSFER = 'store/stock/transfer/'
    static STORE_BATCH_DETAILS_LIST = 'store/batch/details/'
    static STORE_TRANSIT_DETAILS = 'store/indent/transit/details/'
    static STORE_SUB_LOC_STK_LIST = 'store/sublocation/stock/list/'
    static STORE_SUBLOC_LOW_STOCK = 'store/sublocation/low/stock/'
    static STORE_LOW_STOCK = 'store/low/stock/'
    static STORE_SUBLOC_EXPIRY_ALERT = 'store/sublocation/expiry/stock/'
    static STORE_EXPIRY_ALERT = 'store/expiry/stock/'
    static STORE_SUBLOC_WANTED_LIST = 'store/sublocation/wanted/list/'
    static STORE_WANTED_LIST = 'store/wanted/list/'
    static STORE_SUBLOC_PRODUCT_LIST = 'store/sub-loc/product/search/'
    static STORE_SUBLOC_GENERIC_COMSUMPTION = 'store/sublocation/generic/consumption/'
    static STORE_AUDIT_STOCK = 'store/audit/'
    static STORE_AUDIT_STOCK_HOME = 'store/audit/home/'
    static STORE_TRANSFER_LIST_REPORT = 'store/transfer/list/'
    static STORE_STOCK_TRANSFER_REPORT = 'store/stock/transfer/report/'


    static CASH_COUNTER_BILL_SEARCH = 'billing/search/bill/'
    static CASH_COUNTER_PATIENT_SEARCH = 'billing/patient/search/'
    static CASH_COUNTER_MODULE_SEARCH = 'billing/module/search/'
    static CASH_COUNTER_BILLS_GET = 'billing/bills/'
    static CASH_COUNTER_COLLECTION_CARD = 'billing/collection/summary/'
    static CASH_COUNTER_POST = 'billing/receive/op_payment/'
    static CASH_COUNTER_POST_IP = 'billing/receive/ip_payment/'
    static CASH_COUNTER_ADVANCE_POST = 'billing/advance/receive/'
    static CASH_COUNTER_MODULES_GET = "billing/counter/list/"
    static NEW_BILING_CANCEL_REQUEST = 'billing/cancel/request/'
    static CASH_COUNTER_ADVANCE_POST_PHAR = 'pharmacy/advance-collection/'

    // NEW BILLING API
    static NEW_BILLING_OP_SERVICE_GET = 'billing/services/'

    static OP_PENDING_ORDER_LIST = 'billing/accept/order/pending/view/'
    static PENDING_ORDER_LIST_LAB = 'billing/lab/accept/order/pending/view/'
    static PENDING_ORDER_LIST_RAD = 'billing/rad/accept/order/pending/view/'
    static PENDING_ORDER_LIST_INVESTIGATION = 'billing/investigation/accept/order/pending/view/'

    static NEW_BILLING_OP_TEMPLATE_LIST = 'billing/template/list/'
    static NEW_BILLING_OP_TEMPLATE_GET = 'billing/template/data/'
    static NEW_BILLING_PATIENT_SEARCH = 'billing/patient/search/'
    static NEW_BILLING_PATIENT_OP_IP_NUM_LIST = 'billing/module/search/'
    static NEW_BILLING_OP_POST = 'billing/op/billing/'
    static NEW_BILLING_SAVED_BILL_GET = 'billing/op/saved/bills/'
    static DOC_TEST_LABTEST = 'billing/lab/test/'
    static DOC_TEST_RADTEST = 'billing/radiology/service/'
    static DOC_TEST_POST = 'doctorv4/create/test/new/'
    static DOC_TEST_GET = 'doctorv4/tests/list/'
    static NEW_BILLING_OP_ORDER_LIST = 'billing/op/pending/order/'
    static NEW_BILLING_IP_ORDER_GET = 'billing/ip/pending/order/'
    static NEW_BILLING_FINAL_SETTLE_GET = 'billing/ip/final/order/'
    static NEW_BILLING_IP_SETTLEMENT = 'billing/ip/billing/'
    // NEW RADIOLOGY API
    static TEST_TRANSMIT = 'doctorv4/order/create/'
    static IP_TEST_POST = 'ip/notes/order/'
    // NEW RADIOLOGY API
    static NEW_RAD_PATIENT_LIST = 'radiology/home/view/new/'
    static NEW_INVESTIGATION_PATIENT_LIST = 'investigation/home/view/new/'
    static NEW_RAD_SAVED_BILL_GET = 'radiology/saved/bill/view/new/'
    static NEW_RAD_PATIENT_BILLS_GET = 'radiology/bill/view/new/'
    static RAD_PATIENT_BILLS_HISTORY = 'radiology/patient/history/'
    static NEW_INVESTIGATION_PATIENT_BILLS_GET = 'investigation/bill/view/new/'
    static NEW_RAD_RECEIPT_BILL_GET = 'radiology/receipt/bill/list/new/'
    static NEW_BILLING_INDIVIDUAL_BILL_GET = 'billing/individual/bills/'
    static NEW_RAD_PATIENT_ORDER = 'radiology/patient/order/'
    static NEW_INVESTIGATION_PATIENT_ORDER = 'investigation/patient/order/'
    // NEW LAB API
    static NEW_LAB_STATUS_GET = "billing/lab/result/summary/"

    // NEW REPORT OP DETAILS
    static NEW_FO_REPORTS_SERVICE_DETAILED = "fo/op/service/detailed/"
    static NEW_FO_REPORTS_SERVICE_OVERVIEW = "fo/op/service/overview/"
    static NEW_DOCTOR_SHARE_REPORT = "fo/ipop/hospital/doctor/share/"
    static NEW_FO_REPORTS_CONSULT_WISE = "fo/op/consultation/report/"
    static NEW_FO_GST_REPORT = "fo/ipop/gst-report/new/"

    // NEW REPORT IP DETAILS
    static NEW_FO_REPORTS_IP_SERVICE_DETAILED = "ip/new-bill/service-detailed/"
    static NEW_FO_REPORTS_IP_SERVICE_OVERVIEW = "ip/new-bill/service-overview/"
    static NEW_FO_REPORTS_IP_LEGER_REPORT = "ip/new-bill/ledger-report/"
    static NEW_FO_REPORTS_IPADMISSIION = 'ip/new-bill/addmission-list/'

    // NEW REPORT CORPORATE 
    static NEW_FO_REPORTS_CORPORATE_PATIENT = "fo/corporate/patient/report/new/"

    // NEW OP Billing 
    static NEW_FO_PATIENT_APPOINTMENT_SAVED_GET = "billing/op/patient/drafts/"
    static NEW_FO_PATIENT_BILL_DETAILS_GET = "billing/op/patient/bills/"
    static NEW_FO_RECEIPT_BILL = "billing/op/patient/receipts/" // fo receipt bill

    // NEW IP BILLING
    static NEW_IP_PATIENT_INDIVIDUAL_SAVED_BILL = "billing/ip/patient/drafts/"
    static NEW_IP_PATIENT_INDIVIDUAL_BILLS = "billing/ip/patient/bills/"
    static NEW_IP_PATIENT_INDIVIDUAL_RECEIPT_Bill = "billing/ip/patient/receipts/"
    static NEW_IP_PREVIOUS_TEST_RECORDS = 'billing/discharge/summary/test-reports/'
    static NEW_IP_DISCHARGE_SUMMARY_TEST = "billing/inpatient/discharge/summery/labtest/"
    static IP_DISCHARGE_SUMMARY_HISTORY_LOG = "ip/discharge/summary/log"

    // NEW BILLING TRANSACTION
    static NEW_OVERALL_BILLS_GET = "billing/overall/"
    static NEW_CREDIT_BILLS_GET = "billing/credit-bill/"
    static NEW_COMPLETE_BILLS_GET = "billing/saved-bill/"
    static NEW_RECEIPT_REPORT = "billing/receipt/"
    static NEW_DAY_END_STATUS_GET = "billing/dayend/"
    static NEW_FO_ADVANCE_DETAIL = 'billing/advance/adjust/'
    static NEW_FO_RECEIPT_DETAIL = 'billing/receipt/detailed/'

    // NEW RAD REPORT
    static NEW_RAD_CENCUS_REPORT = 'radiology/census/report/new/'
    static NEW_RAD_PATIENT_REPORT = 'radiology/patient/service/report/new/'
    static NEW_RAD_CONSULTANT_WISE_REPORT = "radiology/consultation/rad/wise/report/new/"
    static NEW_RAD_TAT_REPORT = 'radiology/rad/tat/report/new/'

    static NEW_INVESTIGATION_CENCUS_REPORT = 'investigation/census/report/new/'
    static NEW_INVESTIGATION_PATIENT_REPORT = 'investigation/patient/service/report/new/'   
    static NEW_INVESTIGATION_CONSULTANT_WISE_REPORT = "investigation/consultation/rad/wise/report/new/"
    static NEW_INVESTIGATION_TAT_REPORT = 'investigation/rad/tat/report/new/'

    // static NEW_RAD_SAVED_BILL_TRANS_GET = 'radiology/saved/bill/view/new/'

    static NEW_RAD_RECEIPT_BILL_TRANS_GET = 'radiology/receipt-bill/transactions/new/'
    static NEW_RAD_OVER_ALL_BILL_TRANS_GET = 'radiology/overall/transactions/new/'
    static NEW_RAD_CREDIT_BILL_TRANS_GET = 'radiology/credit-bill/transactions/new/'
    static NEW_RAD_DAY_END_BILL_TRANS_GET = 'radiology/day/end/new/'
    static NEW_RAD_SAVED_BILL_TRANS_GET = 'radiology/saved-bill/transactions/new/'
    static NEW_RAD_CANCEL_BILL_TRANS_GET = 'radiology/cancel-bill/transactions/new/'

    static NEW_INVESTIGATION_RECEIPT_BILL_TRANS_GET = 'investigation/receipt-bill/transactions/new/'
    static NEW_INVESTIGATION_OVER_ALL_BILL_TRANS_GET = 'investigation/overall/transactions/new/'
    static NEW_INVESTIGATION_CREDIT_BILL_TRANS_GET = 'investigation/credit-bill/transactions/new/'
    static NEW_INVESTIGATION_DAY_END_BILL_TRANS_GET = 'investigation/day/end/new/'
    static NEW_INVESTIGATION_SAVED_BILL_TRANS_GET = 'investigation/saved-bill/transactions/new/'
    static NEW_INVESTIGATION_CANCEL_BILL_TRANS_GET = 'investigation/cancel-bill/transactions/new/'

    // NEW LAB REPORT
    static NEW_LAB_BILL_REPORT = "lab/bill/report/new/";
    static NEW_LAB_RECEIPT_REPORT = "lab/receipt/report/new/"
    static NEW_LAB_CENSUS_REPORT_OLD = "lab/census/report/new/"
    static NEW_LAB_DAY_END_REPORT_GET = 'lab/dayend/report/new/'
    static NEW_LAB_INSURANCE_REPORT = "lab/receipt/insurance_report/new/"
    static NEW_LAB_SHARE_REPORT_GET = 'lab/share/report/new/'
    static NEW_POSITIVE_CENSUS_REPORT = "lab/census/pos_neg/new/"
    static NEW_LAB_PATIENT_REPORT = "lab/patient/report/new/"
    static NEW_LAB_CONSULTANT_WISE_REPORT = "lab/consultation/wise/lab/report/new/"
    static NEW_FO_REPORTS_CORPORATE_PATIENT = "fo/corporate/patient/report/new/"
    static NEW_LAB_PREVIOUS_REPORT = "lab/report/previous/new/"

    // NEW PHARMACY REPORT
    static NEW_PHARMACY_RECEIPT_BILL_LIST = "billing/pharmacy/day-end/"
    static NEW_FO_CREDIT_BILLS_GET = 'billing/pharmacy/credit/collection/'

    //NEW Bill print 
    static NEW_OP_INVOICE_PRINT = "billing/op-service-bill/print/"
    static NEW_OP_DETAILED_BILL_PRINT = "billing/op-detail-bill/print/"
    static NEW_OP_SUMMARY_BILL_PRINT = "billing/op-summary-bill/print/"
    static NEW_IP_INVOICE_PRINT = "billing/ip-service-bill/print/"
    static NEW_IP_PATIENT_BILL_DETAILED_PRINT = "billing/ip-detail-bill/print/"
    static NEW_IP_ADMISSION_BILL_SUMMARY_PRINT = "billing/ip-summary-bill/print/"
    static NEW_LAB_CREATE_BILL_COMPLETED_PRINT = "billing/lab-bill/print/"
    static NEW_RAD_BILL_POST = 'billing/rad-bill/print/'
    static NEW_INVESTIGATION_BILL_POST = 'investigation/bill/print/'
    static NEW_RECEIPT_INDIV_PRINT = "billing/receipt-bill/print/"
    static NEW_RAD_RESULT_PRINT = 'radiology/bill/service/print/new/'
    static NEW_INVESTIGATION_RESULT_PRINT = 'investigation/bill/service/print/new/'
    static NEW_RAD_BARCODE_PRINT = 'radiology/bill/barcode/new/'
    static NEW_INVESTIGATION_BARCODE_PRINT = 'investigation/bill/barcode/new/'
    static NEW_DAY_END_DETAILD = 'billing/dayend/detail/'
    static New_DOCTOR_NOTES_PRINT = "lab/test/print/new/"
    static NEW_BILLING_ISSUE_DRUG_PRINT = "billing/issued-drug/print/"

    // NEW FO URLS
    static NEW_GET_BILL_MODIFY_HISTORY = "billing/bill/log/"
    static NEW_SERVICE_LIST_REPORT = "billing/service/report/search/"
    static NEW_LAB_PACKAGE = "billing/package/report/search/"
    static NEW_LAB_PACKAGEWISE_REPORT = "lab/package/report/new/"
    static TEST_ORDER_RAD_PRINT = 'radiology/bill/service/print/new/'
    static NEW_CHANGE_CREDIT_PAYMENT = "billing/change/credit-type/"
    static NEW_CREDIT_ADJUSTMENT_REPORT = "fo/credit/settlement/new/"
    static NEW_CONSSESION_REPORT = "fo/concession/report/new/"

    static MODULE_TYPE_LIST_GET = "auth/overall/module/list/"

    //MRD URLS
    static MRD_CATEGORY_GET_POST = "mrd/category/"
    static MRD_RACK_GET_POST = "mrd/rack/"
    static MRD_DEPARTMENT_GET_POST = "mrd/department/"
    static MRD_CONSULT_ROOM_GET_POST = "mrd/consultant-room/"
    static MRD_NURSE_STATION_GET_POST = "mrd/nurse-station-room/"
    static MRD_OTHER_ROOM_GET_POST = "mrd/other-room/"
    static MRD_DOCUMENTS_ADD = "mrd/documents/"
    static MRD_BARCODE_GET = "mrd/mrd-document-barcode/"
    static MRD_DOC_TRANSFER_GET_POST = "mrd/track/"
    static MRD_ROOMS_LIST = "mrd/rooms-and-categories/"
    static MRD_DOC_TRACKER = "mrd/tracking-logs/"
    

    // Order Department wise card url
    static NEW_BILLING_ORDER_DEPTWISE = "billing/reports/deptwise/"
    static NEW_BILLING_BILL_REQUEST = 'billing/op/bill/request/'
    static NEW_BILLING_APPROVER_LIST = 'billing/approver-list/'
    static NEW_BILLING_PENDING_LIST = 'billing/request/list/'
    
    //New auto billing 
    static NEW_AUTO_BILLING_LIST = "billing/auto-bill/services/"
    static NEW_AUTO_SUMMARY = "billing/auto-bill/module-service/"
    static NEW_AUTO_BILLING_GET = "billing/services/auto-billing/"
    
    static PHARMA_PURCHASE_GRN_WISE_REPORT_EXCEL = 'reports/report/purchase_grn_wise/'
    static PHARMA_SALES_GRN_WISE_REPORT_EXCEL = 'reports/report/sales_tax_wise/'
    static PHARMA_DAY_END_DETAIL_SALES_REPORT = 'reports/report/sales_wise_overview/'
    static FO_DAY_END_COLLECTION_REPORT = 'reports/report/fo_collection_overview/'
    // New billing Dashboard Api's
    static NEW_OP_DASH_SPECILIZATION = "billing/op-dash/specilization/"
    static NEW_OP_DASH_DOCTOR = "billing/op-dash/doctor/"
    static NEW_OP_DASH_SERVICES = "billing/op-dash/services/"
    static NEW_OP_DASH_LOCATION = "billing/op-dash/location/"

    static NEW_IP_DASH_SPECILIZATION = "billing/ip-dash/specilization/"
    static NEW_IP_DASH_DOCTOR = "billing/ip-dash/doctor/"
    static NEW_IP_DASH_SERVICES = "billing/ip-dash/services/"
    static NEW_IP_DASH_LOCATION = "billing/ip-dash/location/"

    static NEW_RAD_DASH_DEMOGRAPHIC = "billing/rad-dash/demographics/"
    static NEW_RAD_DASH_TOPTEST = "billing/rad-dash/top-test/"
    static NEW_RAD_DASH_LOCATION = "billing/rad-dash/location/"

    static NEW_PHARMA_DASH_PATIENTBILL = "billing/ph-dash/patient-bill/"
    static NEW_PHARMA_DASH_PURCHASE_SALES = "billing/ph-dash/purchase-sales/"
    static NEW_PHARMA_DASH_TOPDRUG = "billing/ph-dash/top-drug/"
    static NEW_PHARMA_DASH_PURCHASE = "billing/ph-dash/purchase/"
    static NEW_PHARMA_DASH_NOMOVEMENT = "billing/ph-dash/no-movement/"
    static NEW_PHARMA_DASH_EXPIRY_STOCK = "billing/ph-dash/expiry-stock/"
    static NEW_PHARMA_DASH_TOTAL_DRUG = "billing/ph-dash/total-drug/"
    static NEW_PHARMA_DASH_LOW_STOCK = "billing/ph-dash/low-stock/"
    static NEW_PHARMA_DASH_SLOW_MOVEMENT = "billing/ph-dash/slow-movement/"
    static NEW_PHARMA_DASH_NEW_STOCK = "Billing/ph-dash/new-stock/"

    static NEW_LAB_DASH_COMP_TEST = "billing/lab-dash/comp-test/"
    static NEW_LAB_DASH_TOTAL_TEST = "billing/lab-dash/total-test/"
    static NEW_LAB_DASH_DEMOGRAPHIC = "billing/lab-dash/demographics/"
    static NEW_LAB_DASH_TEST = "billing/lab-dash/test/"
    static NEW_LAB_DASH_PURCHASE_SALES = "billing/lab-dash/purchase-sales/"
    static NEW_LAB_DASH_LOCATION = "billing/lab-dash/location/"

    static NEW_OVERALL_DASH_OVERALL_REVENUE = "billing/overall-dash/overall-revenue/"
    static NEW_OVERALL_DASH_APPOINTMENT_COUNT = "billing/overall-dash/appointment-count/"
    static NEW_OVERALL_DASH_CREDIT_AMOUNT = "billing/overall-dash/credit-amount/"
    static NEW_OVERALL_DASH_PAYMENT = "billing/overall-dash/payment/"
    static NEW_OVERALL_DASH_REVENUE = "billing/overall-dash/revenue/"
    static NEW_OVERALL_DASH_PATIENT_DOCTOR = "billing/overall-dash/patient-doctor/"
    static ADD_REFERRAL_NOTES_TEMP = 'doctor/opt/referral/template/'

    // Saras Doctor Notes 
    static SARAS_DOC_COMPLAINTS = "doctorv4/patient-complaints/"
    static SARAS_DOC_COMPLAINTS_TEMP_GET = "doctorv4/patient-complaints/template/"
    static SARAS_DOC_COMPLAINTS_SUGG_GET = "doctorv4/patient-complaints/suggestion/"

    static SARAS_DOC_SYMPTOMS = "doctorv4/patient-symptoms/"
    static SARAS_DOC_SYMPTOMS_TEMP_GET = "doctorv4/patient-symptoms/template/"
    static SARAS_DOC_SYMPTOMS_SUGG_GET = "doctorv4/patient-symptoms/suggestion/"

    static SARAS_DOC_ALLERGIES = "doctorv4/patient-allergies/"
    static SARAS_DOC_ALLERGIES_TEMP_GET = "doctorv4/patient-allergies/template/"
    static SARAS_DOC_ALLERGIES_SUGG_GET = "doctorv4/patient-allergies/suggestion/"

    static SARAS_DOC_PROVDIAGNOSIS = "doctorv4/patient/provisional-diagnosis/"
    static SARAS_DOC_PROVDIAGNOSIS_TEMP_GET = "doctorv4/patient/provisional-diagnosis/template/"
    static SARAS_DOC_PROVDIAGNOSIS_SUGG_GET = "doctorv4/patient/provisional-diagnosis/suggestion/"

    static SARAS_DOC_FNLDIAGNOSIS = "doctorv4/patient/final-diagnosis/"
    static SARAS_DOC_FNLDIAGNOSIS_TEMP_GET = "doctorv4/patient/final-diagnosis/template/"
    static SARAS_DOC_FNLDIAGNOSIS_SUGG_GET = "doctorv4/patient/final-diagnosis/suggestion/"

    static SARAS_DOC_PLAN = "doctorv4/patient/plans/"
    static SARAS_DOC_PLAN_TEMP_GET = "doctorv4/patient/plans/template/"
    static SARAS_DOC_PLAN_SUGG_GET = "doctorv4/patient/plans/suggestion/"

    static SARAS_DOC_TEST_SUGGESTION_GET = "doctorv4/patient/test-service/list/"
    static SARAS_DOC_TEST_DATA = "doctorv4/patient/test-service/create/"

    static SARAS_DOC_GENERALADVICE = "doctorv4/patient/general-advice/"
    static SARAS_DOC_GENERALADVICE_TEMP_GET = "doctorv4/patient/general-advice/template/"
    static SARAS_DOC_GENERALADVICE_SUGG_GET = "doctorv4/patient/general-advice/suggestion/"

    static SARAS_DOC_VITALS = "doctorv4/patient/vitals-new/"
    static SARAS_DOC_PATIENT_CATEGORY_GET = "doctorv4/patient/category-new/"
    static SARAS_DOC_PATIENT_CATEGORY_SUGG_GET = "doctorv4/patient/category-suggestion/"

    static SARAS_DOC_PAINCHART_GET = "doctorv4/patient/pain-chart/"
    static SARAS_DOC_ICD_DIAGNOSIS_GET = "doctorv4/patient/icd-diagnosis/"
    static SARAS_DOC_ICD_DIAG_FREQ_GET = "doctorv4/patient/icd-diagnosis/frequent/"

    static SARAS_DOC_NEW_LAYOUT = "doctorv4/patient/new-layout-data/"
    static SARAS_DOC_NEW_LAYOUT_TEMP_GET = "doctorv4/patient/new-layout-data/template/"
    static SARAS_DOC_NEW_LAYOUT_SUGG_GET = "doctorv4/patient/new-layout-data/suggestion/"

    static SARAS_DOC_REVIEW_PLAN = "doctorv4/patient/review-plan/"
    static SARAS_DOC_REVIEW_PLAN_SUGG_GET = "doctorv4/patient/review-plan/suggestion/"

    static SARAS_DOC_PRESCRIPTION_DATA = "doctorv4/patient/prescription/create/"
    static SARAS_DOC_PRESCRIPTION_FREQUENT = "doctorv4/patient/frequent-prescription/"
    static SARAS_DOC_PRESCRIPTION_FAVOURITE = "doctorv4/patient/favorite-prescription/"
    static SARAS_DOC_PRESCRIPTION_TRANSMIT = "doctorv4/patient/prescription-transmit/"
    static SARAS_DOC_PRESCRIPTION_TEMPLATE = "doctorv4/patient/prescription-template/"
    static SARAS_DOC_PREV_PRESCRIPTION = "doctorv4/patient/prescription-history/"

    static SARAS_DOC_LAST_VISIT_RECORDS = "doctorv4/patient/last-visit-records/"

    static SARAS_DOC_EXAMINATION_GET = "doctorv4/patient/examination-new/"
    static SARAS_DOC_EXAMINATION_TEMP_GET = "doctorv4/patient/examination-new/template/"
    static SARAS_DOC_EXAMINATION_SUGG_GET = "doctorv4/patient/examination-new/suggestion/"

    static SARAS_DOC_VISIT_REPORT_GET = "doctorv4/patient/visit-report/print/"
    static SARAS_DOC_PREVIOUS_ICD_GET = "doctorv4/patient/icd-diagnosis/history/"
    static SARAS_DOC_PREVIOUS_PROVISIONAL_GET = "doctorv4/patient/provisional-diagnosis/history/"
    static SARAS_DOC_PREVIOUS_FINAL_DIAGNOSIS_GET = "doctorv4/patient/final-diagnosis/history/"
    static UMA_DOC_PREVIOUS_DIAGNOSIS_GET = "doctorv4/opt/diagnosis/history/"
    
    static SUPER_ADMIN_LOGIN_ROLE = 'fo/user/role/'
    static SUPER_ADMIN_BRANCH_LIST = 'fo/org/branch-list/'
    static SUPER_ADMIN_DOCTOR_LIST = 'fo/branch/doctor-list/'
    static SUPER_ADMIN_NEW_USER_CREATE = 'fo/org/doctor/user-list/'
    static NURSE_ASSESMENT_LOG_GET = 'ip/nurse/assesment/log/'

    // SARASWATHI IP DOCTOR NOTES API
    static SAR_IP_DOC_NOTES_NEW_LAYOUT_CONFIG = 'ip/clinical-notes/layout/'

    static SAR_IP_DOC_NOTES_NEW_LAYOUT_DATA = 'ip/clinical-notes/new-layout/data/'
    static SAR_IP_DOC_NOTES_NEW_LAYOUT_DATA_SUGG_GET = 'ip/clinical-notes/new-layout/suggestion/'
    static SAR_IP_DOC_NOTES_NEW_LAYOUT_DATA_TEMP_GET = 'ip/clinical-notes/new-layout/template/'
    
    static SAR_IP_DOC_NOTES_SYMPTOMNS = 'ip/custom-symptoms/'
    static SAR_IP_DOC_NOTES_SYMPTOMNS_TEMP_GET = 'ip/custom-symptoms/template/'
    static SAR_IP_DOC_NOTES_SYMPTOMNS_SUGG_GET = 'ip/custom-symptoms/suggestion/'

    static SAR_IP_DOC_NOTES_COMPLAINTS = 'ip/custom-complaints/'
    static SAR_IP_DOC_NOTES_COMPLAINTS_TEMP_GET = 'ip/custom-complaints/template/'
    static SAR_IP_DOC_NOTES_COMPLAINTS_SUGG_GET = 'ip/custom-complaints/suggestion/'

    static SAR_IP_DOC_NOTES_FINALDIAGNOSIS = 'ip/custom-finaldiagnosis/'
    static SAR_IP_DOC_NOTES_FINALDIAGNOSIS_TEMP_GET = 'ip/custom-finaldiagnosis/template/'
    static SAR_IP_DOC_NOTES_FINALDIAGNOSIS_SUGG_GET = 'ip/custom-finaldiagnosis/suggestion/'

    static SAR_IP_DOC_NOTES_PLAN = 'ip/custom-plan/'
    static SAR_IP_DOC_NOTES_PLAN_TEMP_GET = 'ip/custom-plan/template/'
    static SAR_IP_DOC_NOTES_PLAN_SUGG_GET = 'ip/custom-plan/suggestion/'

    static SAR_IP_DOC_NOTES_GENERALADVICE = 'ip/custom-generaladvice/'
    static SAR_IP_DOC_NOTES_GENERALADVICE_TEMP_GET = 'ip/custom-generaladvice/template/'
    static SAR_IP_DOC_NOTES_GENERALADVICE_SUGG_GET = 'ip/custom-generaladvice/suggestion/'

    static SAR_IP_DOC_NOTES_PRODIAGNOSIS = 'ip/custom-diagnosis/'
    static SAR_IP_DOC_NOTES_PRODIAGNOSIS_TEMP_GET = 'ip/custom-diagnosis/template/'
    static SAR_IP_DOC_NOTES_PRODIAGNOSIS_SUGG_GET = 'ip/custom-diagnosis/suggestion/'

    static SAR_IP_DOC_NOTES_EXAMINATION = 'ip/custom-examination/'
    static SAR_IP_DOC_NOTES_EXAMINATION_TEMP_GET = 'ip/custom-examination/template/'
    static SAR_IP_DOC_NOTES_EXAMINATION_SUGG_GET = 'ip/custom-examination/suggestions/'
    
    static SAR_IP_DOC_NOTES_DIAGNOSIS = 'ip/custom-icddiagnosis/'
    static SAR_IP_DOC_NOTES_DIAGNOSIS_SUGG_GET = 'ip/custom-icddiagnosis/frequent/'
    static SAR_IP_DOC_NOTES_DIAGNOSIS_TEMP_GET = 'ip/custom-icddiagnosis/template/'
    static SAR_IP_DOC_NOTES_DIAGNOSIS_TEMPLATE_LINE = 'ip/custom-icddiagnosis/template/line/'

    static SAR_IP_DOC_NOTES_PAINCHART_GET = "ip/custom-painchart/"    
    static SAR_IP_DOC_NOTES_PATIENT_CATEGORY= "ip/custom-patient/category/"
    static SAR_IP_DOC_NOTES_REVIEWPLAN = 'ip/custom/review-plan/'
    static SAR_IP_NOTES_HISTORY = 'ip/custom/notes/history/'
    static SAR_IP_DOC_NOTES_DISCHARGE_SUM = "ip/custom/discharge-summary/doctor-notes/"
    static SAR_IP_DOC_NOTES_PRINT = "ip/custom/visit-report/print/"
    static SAR_IP_DOC_PROGRESSIVE_NOTES_HISTORY = "ip/custom/progressive-notes/history/"

    // Credit Settlement API
    static INSURANCE_PROVIDER_GET = "ip/insurance/provider/"
    static INSURANCE_PROVIDER_INFO_GET = "ip/insurance/provider/info/"
    static INSURANCE_BILL_GET = "ip/insurance/bill/"
    static CORPORATE_PROVIDER_GET = "ip/corporate/provider/"
    static CORPORATE_PROVIDER_INFO_GET = "ip/corporate/provider/info/"
    static CORPORATE_BILL_GET = "ip/corporate/bill/"
    static PATIENT_PROVIDER_INFO_GET = "ip/patient/provider/info/"
    static COMMON_CREDIT_PAYMENT_POST = "ip/credit/settlement/receive-payment/"
    static NEW_CREDIT_PAYMENT_REPORT = "fo/ins-corp/credit/settlement/"
    static GET_MASTER_BANK_DATA = "core/bank/details/"
    static GET_EXTERNAL_DRUG_DATA = "fo/external-drug/config/"

    //Discharge Summary
     static REVERT_DISCHARGE_URL = "ip/revert/discharge/"
     static CURRENT_API_URL = "ip/revert/discharge/";
     static LOG_API_URL = "ip/admin/discharge-revert/";
     static PERFORM_REVERT_URL = "ip/admin/discharge-revert/";

     static REVERT_RADIOLOGY_URL ="ip/revert/radiology/"
     static CURRENT_API_URL_RADIO = "ip/revert/radiology/";
     static LOG_API_URL_RADIO ="ip/admin/radiology-revert/";
     static RADIOLOGY_PERFORM_REVERT="ip/admin/radiology-revert/"

    //
    static OP_TO_IP_MOVE = "fo/patient/appointment/ip-conversion/"
    static ALLERGY_DRUG_VALIDATION = "doctorv4/check/generic-allergy/"
    static GENERIC_MASTER_SUGGESTION = "doctorv4/config/allergy/"
    static IP_REVERT_INITIATED_BILL = "ip/final-bill/revert/"

    // JMO - ClINICAL STAFF
    static JMO_CLINICAL_STAFF_GET = 'doctorv4/clinical-staff/'
    static JMO_CLINICAL_STAFFMAP_GET = 'doctorv4/doctor-clinical-staff/'
    static JMO_APPOINTMENT_GET = 'doctorv4/appointment/list/'
    static JMO_DOCTOR_LIST_GET = 'doctorv4/jmo/linked-doctors/'
    //Laboratory
    static REVERT_LAB_URL = "ip/revert/laboratory/";
    static CURRENT_API_URL_LAB = "ip/revert/laboratory/";
    static LOG_API_URL_LAB = "ip/admin/laboratory-revert/";
    static PERFORM_LAB_URL = "ip/admin/laboratory-revert/";
    static OP_IP_SERVICE_HEAD_WISE_REPORT = 'fo/op-ip-serviceheadwise/report/'
    static LAB_OUTSOURCE_TRANSIT_SUG = 'lab/outsource/transit_detail/'
    static IP_REVERT_INITIATED_BILL_REQUEST = "ip/revert/ip-initiated-bill/"

    static OP_TO_IP_MOVE = "fo/patient/appointment/ip-conversion/"

    // radio therapy masters api
    static RADIO_THERAPY_GET = "radiotherapy/therapy-master/"
    static TREATMENT_REGION_GET="radiotherapy/treatment-region/"
    static TREATMENT_TECHNIQUE_GET = "radiotherapy/therapy-technique/"
    static STIMULATOR_GET = "radiotherapy/stimulator-master/"
    static IMMOBILIZATION_DEVICE_GET = "radiotherapy/immobilization-device/"
    static RADIOTHERAPY_TAG = "radiotherapy/radiotherapy-tag/"
    static ROLE_MASTER_GET ="radiotherapy/role-master/"
    static USER_ACCESS_GET ="radiotherapy/user-access/"

    static GLB_ROLE_MASTER ="fo/role-master/config/"
    static GLB_ROLE_ACCESS_DATA ="fo/role/access-data/"
    static GLB_USER_ACCESS ="fo/user-create/role-mapping/"

    static WHATSAPP_CONFIG = 'fo/whatsapp/request/'
    static WHATSAPP_SEND = 'core/ebill/whatsapp/'
    static WHATSAPP_ALERT_REMOVE = "fo/ignore/whatsapp-threshold/"
    static SUBSCRIPTION_ALERT_REMOVE = "configuration/subscription-alert/"
    
    static DOOR_DELIVERY_REPORT = "pharmacy/billing/door-delivery/"
    static ISSUED_DRUG_REPORT = "billing/issue/drug/report/"
    static NEW_CHANGE_PAYMENT_MODE = "billing/change/receipt/payment-mode/"

    //Change Admission Type
    static CHANGE_ADMISSION_TYPE = "ip/revert/admissionType/";
    static CURRENT_ADMISSION_TYPE = "ip/revert/admissionType/";
    static LOG_ADMISSION_TYPE = "ip/admin/admissionType-revert/";
    static ADMISSION_TYPE_PERFORM_REVERT = "ip/admin/admissionType-revert/";
    
    static GENERAL_EXAMINATION_GET = "doctorv4/general-examination/"
    static GENERAL_EXAMINATION_SIGN_GET = "doctorv4/general-examination/sign/"
    static GENERAL_EXAMINATION_SUGGESTION_GET = "doctorv4/general-examination/group/"
    static GENERAL_EXAMINATION_TEMPLATE_GET = "doctorv4/general-examination/template/"
    static DOC_DOCTOR_NOTES_PRESENTINGILLNESS_GET = 'doctor/presenting-illness/'
    static DOC_PRESENTINGILLNESS_SUGGESTION_GET = 'doctor/presenting-illness/suggestions/'

    static NEW_DAY_END_REPORT = 'fo/new/day-end/'
    static NEW_DAY_END_REPORT_CARD = 'fo/new/day-end/summary/'
    static AI_DOCTOR_NOTES_TEXT_CONVERT = 'doctorv4/ai/doctor/notes/'
    static AI_DOCTOR_NOTES_MEDICATION = 'doctorv4/ai/notes/drug/search/'
    static AI_DOCTOR_NOTES_DETAILS = 'doctorv4/ai/notes/credit/limit/'
    static AI_COLLAB_SUMMARY = 'doctorv4/ai/collabrative/summary/'

    //membership apis
    static MEMBERSHIP_PACKAGE_CONFIG = 'billing/membership/config/'
    static MEMBERSHIP_MEMBER_ADD = 'billing/membership/member/add/'
    static MEMBERSHIP_MEMBER_REPORT = 'billing/membership/reports/'
    static MEMBERSHIP_MEMBER_BILLS = 'billing/members/availed/bills/'
    static MEMBERSHIP_MEMBER_CARD_PRINT = 'billing/membership/card/print/'

    static PATIENT_TRACK_FOR_UMA = 'doctorv4/patient/track/'
    //other Doctor List
    static OTHER_DOCTOR_LIST_GET = 'doctorv4/doctorlist/'
    static DOCTOR_REQUST_APPROVAL = 'doctorv4/doctoraccessrequest/'

    static RT_DOCTOR_TRANSMIT = "radiotherapy/patient/therapy/"
    static RT_PACKAGE_LIST = "radiotherapy/package/search/"
    static RT_STIMULATOR_LIST = "radiotherapy/stimulator/patients/"
    static RT_DOSIMETRIST_LIST = "radiotherapy/dosimetrist/patients/"
    static RT_DOSIMETRIST_UPDATE = "radiotherapy/patient/therapy/"
    static RT_DOCTORS_APPROVAL_LIST = "radiotherapy/doctor/approval/list/"
    static RT_SCHEDULER_LIST = "radiotherapy/scheduler/list/"
    static RT_THERAPIST_LIST = "radiotherapy/therapist/list/"
    static RT_THERAPIST_SESSIONS = "radiotherapy/patient/therapy/sessions/"
    static RT_THERAPIST_UPDATE = "radiotherapy/therapist/list/"
    static RT_DOCTOR_UPDATE = "radiotherapy/doctor/status/change/"
    static RT_WALKIN_APPOINTMENTS = "radiotherapy/walk-in/appointment/"
    static RT_RECEIVE_PAYMENTS = "radiotherapy/receive/payment/"
    static RT_WALKIN_UPDATE = "radiotherapy/walk-in/appointment/"
    static RT_TAT_REPORT = "radiotherapy/session/tat/report/"
    static RT_DETAILED_PRINT = "radiotherapy/bill/print/"
    static RT_TREATMENT_PRINT = "radiotherapy/treatment/summary/print/"
    
    static FO_DRUG_MASTER = 'fo/drug/master/'
    static GET_STOCK_LIST = 'pharmacy/drug-gst-update/'
    static TELE_REQUEST = 'fo/telemedicine/request/'

    static TELE_START_CALL = 'fo/telemedicine/start/call/'
    static TELE_END_CALL = 'fo/telemedicine/end/call/'
    
    static GET_IP_ORDERS_FOR_ADJUST = 'billing/ip/order/list/'
    static IP_PRINT_CONFIG ='billing/detailed-print/configuration/'
    static IP_PRINT_CONFIG_PREVIEW ='billing/ip-detailed-print/'
    static IP_DETAILED_PRINT_FO ="billing/ip-detailed-print/"
    static SMS_MESSAGE_REPORT = 'sms/message/list/'
    static DOCTOR_SERVICE_CONSOLIDATE = 'fo/doctor/service/overview/'
   
    //Medical record configuration 
    static Medical_Record_PRINT_CONFIG_PREVIEW ='fo/medical/record/print/'
    static Medical_Record_PRINT_FO ="fo/medical/record/configuration/"

    static SARAS_DOCNOTE_TEMPLATE = 'doctorv4/doctor-notes-template/'
    static SARAS_DOCNOTE_TEMPOST = 'doctorv4/doctor-notes-assign-to-appointment/'
    static PHARMA_EXTERNAL_DOCTOR = 'pharmacy/pharmacy-referred-doctor/'
    static ATTENDER_CARD_CONFIG = 'fo/attender-card/print-configuration/'
    static ATTENDER_CARD_PRINT = 'fo/attender-card/'

    static NET_GST_REPORT = 'pharmacy/net/tax/wise/report/'
    static TELE_REPORT = 'fo/telemedicine/report/'
    static TELE_GET_DATA = 'fo/telemedicine/get-data/'

    static IP_MEDICATION_USAGE_LIST = 'ip/medication/usage_list/'
    static DOC_ANTERIOR_TEMPLATE_GET = 'doctor/opt/anterior/image/template/'
    static DOC_FUNDUS_TEMPLATE_GET = 'doctor/opt/fundus/image/template/'

    static SERVICE_HEAD_RADIOLOGY = "billing/service/radiology-heads/"
    static IP_REQUEST_DENY = 'pharmacy/medication/list/'
    static MEDICATION_RECALL_LIST = 'ip/medications/recall'

    static BULK_CROP_CREDIT_SETTLEMENT = 'ip/corporate/setllement/bulk/receive/'
    static RAD_REFERRAL_DOCTOR = 'radiology/referral/doctor/'
    static RAD_ROLE_MASTER_GET = 'radiology/esign/role/'
    static RAD_ESIGN_GET = 'radiology/esign/'
    
    static RESCHEDULE_REASON = 'fo/reschedule-reason/'
    
    static OPT_SUGGESTION_POSTERIOR_SEGMENT = 'doctor/opt/posterior/segment/suggestion/'
    static FO_FUTURE_APPOINTMENTS = 'fo/future-appointment/'
    static FO_SERVICE_VALID_UPTO = 'fo/valid-upto/popup/'

    static LAB_SUB_HEADING_POST = 'lab/test/grp/subheading/'
}

